/* fruvi – Abo-Portal „Meine Abos“ auf Basis der Appstle Storefront API über den Shopify App Proxy.
   Übernommen aus dem Rübenretter-Theme (assets/bd-abo-portal.js), Texte und Optik für fruvi.
   Endpunkt-Referenz: docs/appstle-storefront-api.md, Bestellschluss: docs/abo-portal.md */
(function () {
  'use strict';

function mount() {
  /* Jeder Mount bekommt eine Nummer – Listener älterer Mounts (Theme-Editor lädt die Section neu) bleiben stumm */
  var MOUNT = window.__frpMount = (window.__frpMount || 0) + 1;
  var root = document.querySelector('.frp[data-section-id]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var cfgEl = document.getElementById('frp-config-' + sectionId);
  var app = document.getElementById('frp-app-' + sectionId);
  if (!cfgEl || !app) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------- Hilfsfunktionen ---------- */
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MON_S = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var MON_XS = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var DAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var DAYS_S = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(id) {
    if (id == null) return null;
    var m = String(id).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }
  function money(n) {
    var v = Number(n || 0);
    return v.toFixed(2).replace('.', ',') + ' €';
  }
  function parseDate(v) {
    if (!v) return null;
    if (v instanceof Date) return v;
    var d = new Date(v);
    if (isNaN(d.getTime())) {
      var m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }
    return isNaN(d.getTime()) ? null : d;
  }
  /* Datum im Appstle-Format (z. B. DD-MM-YYYY) lesen */
  function parseByFormat(str, fmt) {
    if (!str) return null;
    var parts = String(str).match(/\d+/g);
    if (!parts || parts.length < 3) return null;
    var tokens = ['YYYY', 'MM', 'DD'].map(function (tk) { return { tk: tk, i: String(fmt || 'DD-MM-YYYY').indexOf(tk) }; })
      .filter(function (x) { return x.i >= 0; }).sort(function (a, b) { return a.i - b.i; });
    if (tokens.length < 3) return null;
    var v = {};
    tokens.forEach(function (x, idx) { v[x.tk] = Number(parts[idx]); });
    if (v.YYYY < 100) v.YYYY += 2000;
    var d = new Date(v.YYYY, v.MM - 1, v.DD);
    return isNaN(d.getTime()) ? null : d;
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function fmtShort(d) { return d ? DAYS_S[d.getDay()] + ', ' + d.getDate() + '. ' + MON_S[d.getMonth()] : '–'; }
  function fmtLong(d) { return d ? DAYS[d.getDay()] + ', ' + d.getDate() + '. ' + MONTHS[d.getMonth()] : '–'; }
  function dayKey(d) { return d ? d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() : ''; }
  function unwrap(res) {
    if (res && typeof res === 'object' && !Array.isArray(res)) {
      if (Array.isArray(res.content)) return res.content;
      if (Array.isArray(res.data)) return res.data;
      if (Array.isArray(res.nodes)) return res.nodes;
      if (Array.isArray(res.edges)) return res.edges.map(function (e) { return e.node || e; });
    }
    return Array.isArray(res) ? res : [];
  }
  function intervalDays(policy) {
    if (!policy) return 7;
    var c = Number(policy.intervalCount || 1);
    var unit = String(policy.interval || 'WEEK').toUpperCase();
    return unit === 'DAY' ? c : unit === 'MONTH' ? c * 30 : unit === 'YEAR' ? c * 365 : c * 7;
  }
  function rhythmLabel(policy) {
    if (!policy) return '';
    var c = Number(policy.intervalCount || 1);
    var unit = String(policy.interval || 'WEEK').toUpperCase();
    if (unit === 'WEEK') return c === 1 ? 'Jede Woche' : c === 2 ? 'Alle 14 Tage' : 'Alle ' + c + ' Wochen';
    if (unit === 'DAY') return c === 7 ? 'Jede Woche' : c === 14 ? 'Alle 14 Tage' : 'Alle ' + c + ' Tage';
    if (unit === 'MONTH') return c === 1 ? 'Jeden Monat' : 'Alle ' + c + ' Monate';
    return c === 1 ? 'Jedes Jahr' : 'Alle ' + c + ' Jahre';
  }

  var ICON = {
    back: '<svg class="frp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7M19 12H5"/></svg>',
    pin: '<svg class="frp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    box: '<svg class="frp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="M3.29 7 12 12l8.71-5"/><path d="M12 22V12"/></svg>',
    cal: '<svg class="frp-icon frp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
    card: '<svg class="frp-icon frp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
    pinMd: '<svg class="frp-icon frp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    close: '<svg class="frp-icon frp-icon--md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'
  };

  /* ---------- Appstle-Client ---------- */
  var API_BASE = String(cfg.proxyPath).replace(/\/+$/, '') + '/cp/api';

  /* Beschriftung einer Rhythmus-Option, wie Appstle sie je nach Endpunkt anders benennt. */
  function freqLabel(f) {
    if (!f) return '';
    return f.name || f.label || f.frequencyName || f.sellingPlanName ||
      rhythmLabel({ interval: f.interval || f.billingInterval, intervalCount: f.intervalCount || f.billingIntervalCount });
  }
  /* Laeuft das Abo bereits in diesem Rhythmus? */
  function istAktiverRhythmus(c, f) {
    if (!c || !f) return false;
    if (f.selected === true || f.current === true) return true;
    if (c.box && f.sellingPlanId && num(f.sellingPlanId) === num(c.box.sellingPlanId)) return true;
    return !f.sellingPlanId && freqLabel(f) === rhythmLabel(c.billingPolicy || c.deliveryPolicy);
  }

  function buildQuery(q) {
    if (!q) return '';
    var parts = [];
    Object.keys(q).forEach(function (k) {
      if (q[k] === undefined || q[k] === null || q[k] === '') return;
      parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(q[k]));
    });
    return parts.length ? '?' + parts.join('&') : '';
  }

  function api(method, path, opts) {
    opts = opts || {};
    if (cfg.designMode) { var de = new Error('Im Theme-Editor ist das Portal nur eine Vorschau mit Beispieldaten.'); de.status = 0; return Promise.reject(de); }
    var url = API_BASE + path + buildQuery(opts.query);
    var init = { method: method, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (opts.body !== undefined) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(opts.body);
    }
    /* Zeitlimit: haengt Appstle, zeigt das Portal einen Fehler statt endlos den Ladekreis */
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, API_TIMEOUT) : null;
    if (ctrl) init.signal = ctrl.signal;
    return fetch(url, init).then(function (res) {
      clearTimeout(timer);
      return res.text().then(function (text) {
        var data = null;
        if (text) { try { data = JSON.parse(text); } catch (e) { data = text; } }
        if (!res.ok) {
          var msg = (data && typeof data === 'object' && (data.message || data.detail || data.title || data.error)) || (typeof data === 'string' && data.slice(0, 200)) || ('Fehler ' + res.status);
          var err = new Error(msg);
          err.status = res.status;
          err.data = data;
          state.lastError = { method: method, url: url, status: res.status, body: typeof data === 'string' ? data.slice(0, 600) : JSON.stringify(data).slice(0, 600) };
          try { console.warn('[Abo-Portal] Appstle-Fehler', state.lastError); } catch (e) {}
          throw err;
        }
        return data;
      });
    }, function (err) {
      clearTimeout(timer);
      var e = new Error(err && err.name === 'AbortError' ? 'Appstle antwortet gerade sehr langsam. Bitte versuch es gleich noch einmal.' : 'Keine Verbindung zu Appstle.');
      e.status = 0; e.network = true;
      throw e;
    });
  }
  var API_TIMEOUT = 20000;

  var Appstle = {
    validIds: function (cid) { return api('GET', '/subscription-customers/valid/' + cid); },
    contract: function (id) { return api('GET', '/subscription-contracts/contract-external/' + id); },
    upcoming: function (id) { return api('GET', '/subscription-billing-attempts/top-orders', { query: { contractId: id } }); },
    past: function (id) { return api('GET', '/subscription-billing-attempts/past-orders', { query: { contractId: id, page: 0, size: 12, sort: 'billingDate,desc' } }); },
    fulfillments: function (id) { return api('GET', '/subscription-contract-details/subscription-fulfillments/' + id); },
    skip: function (id, attemptId) { return api('PUT', '/subscription-billing-attempts/skip-order/' + attemptId, { query: { subscriptionContractId: id } }); },
    unskip: function (id, attemptId) { return api('PUT', '/subscription-billing-attempts/unskip-order/' + attemptId, { query: { subscriptionContractId: id } }); },
    skipUpcoming: function (id) { return api('PUT', '/subscription-billing-attempts/skip-upcoming-order', { query: { contractId: id } }); },
    status: function (id, status, extra) { return api('PUT', '/subscription-contracts-update-status', { query: Object.assign({ contractId: id, status: status }, extra || {}) }); },
    cancel: function (id, feedback, note) { return api('DELETE', '/subscription-contracts/' + id, { query: { cancellationFeedback: feedback, cancellationNote: note } }); },
    frequencies: function (id) { return api('GET', '/data/v2/compatible-selling-plan-frequencies', { query: { contractId: id } }); },
    setFrequency: function (id, opt) {
      if (opt.frequencyKey) return api('PUT', '/subscription-contracts-update-frequency-by-compatible-plan', { query: { contractId: id, frequencyKey: opt.frequencyKey, sellingPlanId: opt.sellingPlanId } });
      /* Verkaufsplan aus dem Theme (Liquid) gewählt: Vertrag auf diesen Selling Plan umstellen */
      return api('PUT', '/subscription-contracts-update-frequency-by-selling-plan', { query: { contractId: id, sellingPlanId: opt.sellingPlanId } });
    },
    replaceVariant: function (id, line, newVariantId) {
      /* 1. Versuch: Appstle „replace-variants-v3“ (alte/neue Varianten als Listen, Ziel-Zeile über oldLineId, Mengen
         in allen gängigen Schreibweisen; Parameter als Query UND JSON-Body).
         Schlägt das fehl (z. B. Shopify: „Contract draft must have at least one line“, weil Appstle die alte Zeile
         entfernt, die neue aber nicht anlegt), läuft der Tausch zweistufig über die einfachen Endpunkte:
         erst neue Box als Abo-Zeile hinzufügen, dann die bisherige Zeile entfernen. So gibt es nie einen leeren Vertrag. */
      var qty = Number(line.quantity) || 1;
      var params = {
        contractId: id,
        oldVariantIds: [line.variantId], newVariantIds: [newVariantId],
        oldVariantId: line.variantId, newVariantId: newVariantId,
        oldLineId: line.lineId, lineId: line.lineId,
        quantity: qty, quantities: [qty], newQuantity: qty,
        isOneTimeProduct: false,
        discountCarryForward: 'PRODUCT_THEN_EXISTING'
      };
      var query = Object.assign({}, params, { oldVariantIds: params.oldVariantIds.join(','), newVariantIds: params.newVariantIds.join(','), quantities: params.quantities.join(',') });
      return api('POST', '/subscription-contract-details/replace-variants-v3', { query: query, body: params }).then(null, function (err) {
        var st = err && err.status;
        if (st === 401 || st === 403) throw err;
        try { console.warn('[Abo-Portal] replace-variants-v3 fehlgeschlagen, tausche zweistufig', err && err.message); } catch (e) {}
        return Appstle.swapTwoStep(id, line, newVariantId, qty);
      });
    },
    swapTwoStep: function (id, line, newVariantId, qty) {
      return Appstle.addLine(id, newVariantId, qty, false).then(function () {
        return Appstle.removeLine(id, line.lineId).then(null, function (err) {
          var e = new Error('Die neue Box ist drin, die bisherige konnte aber nicht entfernt werden (' + (err && err.message) + '). Bitte melde dich kurz bei uns.');
          e.status = err && err.status; e.partial = true;
          throw e;
        });
      });
    },
    addLine: function (id, variantId, qty, oneTime) {
      return api('PUT', '/v2/subscription-contracts-add-line-item', { query: { contractId: id, variantId: variantId, quantity: qty, isOneTimeProduct: oneTime !== false } });
    },
    lineQty: function (id, lineId, qty) { return api('PUT', '/subscription-contracts-update-line-item-quantity', { query: { contractId: id, lineId: lineId, quantity: qty } }); },
    removeLine: function (id, lineId) { return api('PUT', '/subscription-contracts-remove-line-item', { query: { contractId: id, lineId: lineId, removeDiscount: true } }); },
    address: function (id, addr) { return api('PUT', '/subscription-contracts-update-shipping-address', { query: { contractId: id }, body: addr }); },
    note: function (id, note) { return api('PUT', '/subscription-contracts-update-order-note/' + id, { query: { orderNote: note }, body: { orderNote: note } }); },
    paymentEmail: function (id) { return api('PUT', '/subscription-contracts-update-payment-method', { query: { contractId: id } }); }
  };

  /* ---------- Modell ---------- */
  var boxVariants = {}; (cfg.boxes || []).forEach(function (b) { boxVariants[b.id] = b; });
  var extraVariants = {}; (cfg.extras || []).forEach(function (x) { extraVariants[x.id] = x; });

  /* Extras eines Abos: eine Liste für alle Boxen (Section-Einstellung „Zusatzprodukte im Portal“). */
  function extrasFor() {
    return cfg.extras || [];
  }


  function normalizeContract(raw, fallback) {
    raw = raw || {};
    var lines = unwrap(raw.lines).map(function (l) {
      var attrs = {};
      (l.customAttributes || []).forEach(function (a) { if (a && a.key) attrs[a.key] = a.value; });
      var price = l.currentPrice ? Number(l.currentPrice.amount) : (l.price != null ? Number(l.price) : 0);
      return {
        lineId: l.id, variantId: num(l.variantId), productId: num(l.productId),
        title: l.title || l.productTitle || '', variantTitle: (l.variantTitle && l.variantTitle !== 'Default Title') ? l.variantTitle : '',
        quantity: Number(l.quantity || 1), price: price, lineTotal: l.lineDiscountedPrice ? Number(l.lineDiscountedPrice.amount) : price * Number(l.quantity || 1),
        sellingPlanId: l.sellingPlanId, attrs: attrs,
        isExtra: !!extraVariants[num(l.variantId)]
      };
    });
    var box = lines.filter(function (l) { return boxVariants[l.variantId]; })[0] || lines.filter(function (l) { return !l.isExtra; })[0] || lines[0] || null;
    var extras = lines.filter(function (l) { return l.isExtra; });
    var dm = raw.deliveryMethod || {};
    var addr = dm.address || (raw.deliveryAddress) || {};
    var pm = raw.customerPaymentMethod || {};
    var inst = pm.instrument || {};
    var status = String(raw.status || (fallback && fallback.status) || 'ACTIVE').toUpperCase();
    var id = num(raw.id) || (fallback && num(fallback.id));
    var next = parseDate(raw.nextBillingDate || (fallback && fallback.nextBillingDate));
    var attrs = box ? box.attrs : {};
    var cattrs = {};
    (raw.customAttributes || []).forEach(function (a) { if (a && a.key) cattrs[a.key] = a.value; });
    var attrName = cfg.deliveryAttribute || 'Liefertermin';
    var attrDate = parseByFormat(cattrs[attrName] || attrs[attrName] || '', cfg.deliveryDateFormat);
    return {
      id: id, status: status,
      nextBillingDate: next,
      createdAt: parseDate(raw.createdAt),
      billingPolicy: raw.billingPolicy || null, deliveryPolicy: raw.deliveryPolicy || null,
      lines: lines, box: box, extras: extras,
      address: {
        firstName: addr.firstName || '', lastName: addr.lastName || '', company: addr.company || '',
        address1: addr.address1 || '', address2: addr.address2 || '', city: addr.city || '', zip: addr.zip || '',
        province: addr.province || '', provinceCode: addr.provinceCode || '', country: addr.country || '', countryCode: addr.countryCode || addr.countryCodeV2 || '',
        phone: addr.phone || ''
      },
      payment: inst.lastDigits ? { brand: inst.brand || '', last4: inst.lastDigits, month: inst.expiryMonth, year: inst.expiryYear, type: inst.__typename || '' } : (inst.__typename ? { brand: inst.__typename.replace(/^Customer/, ''), last4: '', type: inst.__typename } : null),
      note: raw.note || '',
      deliveryDay: attrs['_Delivery Day'] || attrs['Lieferung'] || '',
      deliveryAttrDate: attrDate,
      attempts: null, history: null, frequencies: null,
      _raw: raw
    };
  }

  function deliveryDate(c, billing) {
    /* Ohne konkreten Abrechnungstermin gilt der von Appstle gepflegte Liefertermin (Bestell-Attribut), sonst Abrechnung + Offset */
    if (!billing && c.deliveryAttrDate) {
      var today = new Date(); today.setHours(0, 0, 0, 0);
      if (c.deliveryAttrDate >= addDays(today, -1)) return c.deliveryAttrDate;
    }
    var d = billing || c.nextBillingDate;
    return d ? addDays(d, Number(cfg.deliveryOffsetDays || 0)) : null;
  }
  function boxTitle(c) {
    if (!c.box) return 'Abo';
    var b = boxVariants[c.box.variantId];
    return b ? b.product : c.box.title;
  }
  function boxSize(c) {
    if (!c.box) return '';
    var b = boxVariants[c.box.variantId];
    return b ? b.variant : c.box.variantTitle;
  }
  function boxPrice(c) { return c.box ? c.box.lineTotal : 0; }
  function statusBadge(c, short) {
    if (c.status === 'ACTIVE') return ['green', short ? 'Aktiv' : 'Abo aktiv'];
    if (c.status === 'PAUSED') return ['yellow', 'Pausiert'];
    if (c.status === 'CANCELLED' || c.status === 'EXPIRED') return ['orange', 'Gekündigt'];
    if (c.status === 'FAILED') return ['orange', 'Zahlung offen'];
    return ['yellow', c.status];
  }
  function addressLine(c) {
    var a = c.address;
    var parts = [];
    if (a.address1) parts.push(a.address1);
    if (a.zip || a.city) parts.push([a.zip, a.city].filter(Boolean).join(' '));
    return parts.join(', ');
  }
  function queuedAttempts(c) {
    var seen = {}, out = [];
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var add = function (a, futureOnly) {
      var s = String(a.status || '').toUpperCase();
      if (!(s === 'QUEUED' || s === 'SKIPPED' || s === 'SCHEDULED' || s === 'PENDING')) return;
      var d = parseDate(a.billingDate); if (!d) return;
      if (futureOnly && d < today) return;
      var key = a.id != null ? String(a.id) : dayKey(d);
      if (seen[key]) return; seen[key] = 1; out.push(a);
    };
    (c.attempts || []).forEach(function (a) { add(a, false); });
    (c.history || []).forEach(function (a) { add(a, true); }); /* übersprungene Termine in der Zukunft */
    return out.sort(function (a, b) { return parseDate(a.billingDate) - parseDate(b.billingDate); });
  }
  /* Bisherige Lieferungen: nur Vergangenes (übersprungene Zukunftstermine stehen unter „Die nächsten Wochen“) */
  function pastAttempts(c) {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    return (c.history || []).filter(function (a) {
      var s = String(a.status || '').toUpperCase(), d = parseDate(a.billingDate || a.attemptTime);
      return s === 'SUCCESS' || s === 'FAILURE' || s === 'FAILED' || (d && d < today);
    });
  }
  function nextAttempt(c) {
    return queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() !== 'SKIPPED'; })[0] || null;
  }
  /* --- Bestellschluss -------------------------------------------------------
     Ab cfg.cutoffDays Tagen vor der Lieferung steht der Inhalt fest: die
     Kommissionierliste ist raus. Der Kunde kann dann nichts mehr an dieser
     Lieferung aendern. Offen bleiben bewusst drei Dinge, siehe
     docs/abo-portal-bestellschluss.md: Adresse, Zahlart und Kuendigung. */
  function cutoffTage() {
    var n = Number(cfg.cutoffDays);
    return isFinite(n) && n > 0 ? n : 0;
  }
  /* Letzter Liefertag, der noch als "in Vorbereitung" gilt. */
  function cutoffGrenze() {
    var t = new Date(); t.setHours(0, 0, 0, 0);
    return addDays(t, cutoffTage());
  }
  /* Liegt dieser Liefertag innerhalb des Bestellschlusses? */
  function terminGesperrt(d) {
    if (!cutoffTage() || !d) return false;
    var x = new Date(d); x.setHours(0, 0, 0, 0);
    return x <= cutoffGrenze();
  }
  /* Vertragsweite Aenderungen sind gesperrt, sobald die naechste Lieferung ansteht. */
  function aboGesperrt(c) {
    if (!cutoffTage() || !c) return false;
    var na = nextAttempt(c);
    return terminGesperrt(deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate));
  }

  var PAUSE_MAX = 10;
  /* Termine, die beim Pausieren übersprungen werden können: die geplanten Bestellungen aus Appstle;
     kennt Appstle keine, werden sie aus nächstem Abrechnungstermin und Rhythmus hochgerechnet (id = null → skip-upcoming) */
  function pauseOptions(c) {
    if (c.attempts === null) return []; /* Termine laden noch – Dialog zeigt den Spinner */
    var real = queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() !== 'SKIPPED'; })
      .map(function (a) { return { id: a.id, billing: parseDate(a.billingDate) }; })
      .filter(function (o) { return o.billing; }).slice(0, PAUSE_MAX);
    if (real.length) return real;
    if (!c.nextBillingDate) return [];
    var step = intervalDays(c.billingPolicy || c.deliveryPolicy), out = [];
    for (var i = 0; i < PAUSE_MAX; i++) out.push({ id: null, billing: addDays(c.nextBillingDate, i * step) });
    return out;
  }

  /* ---------- State ---------- */
  var state = { contracts: [], selectedId: null, dialog: null, dialogData: {}, toast: null, busy: false, error: null, needsLogin: false, boxProduct: null, lastError: null, debugRaw: {} };
  var toastTimer = null;

  /* ---------- Zwischenspeicher (sessionStorage) ----------
     Beim erneuten Aufruf im selben Tab stehen die Abos sofort da (Stand der letzten Anzeige), Appstle
     aktualisiert im Hintergrund. Gilt 15 Minuten und nur fuer dieselbe Kunden-ID; der Tab loescht ihn beim Schliessen. */
  var CACHE_KEY = 'frp-cache-v1', CACHE_TTL = 15 * 60 * 1000;
  function slimAttempt(a) { var o = {}; Object.keys(a || {}).forEach(function (k) { if (k !== 'raw') o[k] = a[k]; }); return o; }
  function saveCache() {
    if (cfg.designMode || !cfg.customerId || state.refreshing) return;
    try {
      var list = state.contracts.filter(function (c) { return c._raw && c._raw.id; }).map(function (c) {
        return { raw: c._raw, attempts: c.attempts && c.attempts.map(slimAttempt), history: c.history && c.history.map(slimAttempt), fulfillments: c.fulfillments || null, frequencies: c.frequencies };
      });
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ customerId: cfg.customerId, at: Date.now(), contracts: list }));
    } catch (e) { /* voll oder gesperrt: dann eben ohne */ }
  }
  function loadCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (!c || c.customerId !== cfg.customerId || Date.now() - c.at > CACHE_TTL || !c.contracts || !c.contracts.length) return null;
      return c.contracts.map(function (x) {
        var n = normalizeContract(x.raw);
        n.attempts = x.attempts; n.history = x.history; n.fulfillments = x.fulfillments; n.frequencies = x.frequencies;
        return n;
      });
    } catch (e) { return null; }
  }
  function clearCache() { try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {} }
  function sortContracts(list) {
    var order = { ACTIVE: 1, FAILED: 2, PAUSED: 3, CANCELLED: 4, EXPIRED: 5 };
    return list.sort(function (a, b) { return (order[a.status] || 9) - (order[b.status] || 9) || (b.createdAt || 0) - (a.createdAt || 0); });
  }
  function setRefreshing(b) { state.refreshing = !!b; app.classList.toggle('is-refreshing', !!b); }

  function showToast(msg, variant) {
    clearTimeout(toastTimer);
    state.toast = { msg: msg, variant: variant || 'success' };
    renderToast();
    toastTimer = setTimeout(function () { state.toast = null; renderToast(); }, variant === 'error' ? 6000 : 3400);
  }
  function setBusy(b) { state.busy = b; app.classList.toggle('is-busy', b); }
  function selected() {
    return state.contracts.filter(function (c) { return c.id === state.selectedId; })[0] || null;
  }

  /* ---------- Laden ---------- */
  function byId(id) { return state.contracts.filter(function (c) { return c.id === id; })[0] || null; }
  function fetchContract(id, fb) {
    return Appstle.contract(id).then(function (raw) { return normalizeContract(raw, fb); }, function (err) {
      if (!fb || !fb.status) throw err;
      /* Appstle antwortet nicht – das Kunden-Metafeld reicht für eine Grundansicht */
      return normalizeContract({ id: id, status: fb.status, nextBillingDate: fb.nextBillingDate, lines: (fb.lineItems || []).map(function (li) { return { title: li.title, variantId: li.variantId, quantity: 1 }; }) }, fb);
    });
  }
  /* Termine und Rhythmen hängen nur an der Vertrags-ID – sie werden parallel zum Vertrag geholt, nicht erst danach */
  var prefetch = {};
  function startPrefetch(id) {
    if (!prefetch[id]) prefetch[id] = { attempts: fetchAttempts(id), freq: Appstle.frequencies(id).then(unwrap, function () { return []; }) };
  }
  function takePrefetch(id) { var p = prefetch[id]; delete prefetch[id]; return p; }
  function fetchFrequencies(c, pre) {
    /* Liefert Appstle keine Optionen, kommen die Verkaufspläne des gebuchten Box-Produkts aus dem Theme */
    var p = pre ? pre.freq : Appstle.frequencies(c.id).then(unwrap, function () { return []; });
    return p.then(function (list) { return list.length ? list : liquidFrequencies(c); });
  }
  var inflight = {};
  /* Termine, Historie und Rhythmen nachladen. Schreibt immer auf das aktuelle Objekt in state (Verträge werden beim
     Neuladen ersetzt) und gibt null zurück, wenn nichts zu laden ist – dann ist auch kein Neu-Rendern nötig. */
  function loadDetailData(c) {
    var needAttempts = c.stale || !c.attempts || !c.history, needFreq = c.stale || !c.frequencies;
    if (!needAttempts && !needFreq) return null;
    if (inflight[c.id]) return inflight[c.id];
    var jobs = [], pre = takePrefetch(c.id);
    if (needAttempts) jobs.push((pre ? pre.attempts : fetchAttempts(c.id)).then(function (r) { var x = byId(c.id); if (x) { x.attempts = r.attempts; x.history = r.history; x.fulfillments = r.fulfillments; } }));
    if (needFreq) jobs.push(fetchFrequencies(c, pre).then(function (f) { var x = byId(c.id); if (x) x.frequencies = f; }));
    var done = function () { var x = byId(c.id); if (x) x.stale = false; delete inflight[c.id]; saveCache(); };
    inflight[c.id] = Promise.all(jobs).then(done, done);
    return inflight[c.id];
  }
  /* Verträge laden. Die IDs aus dem Kunden-Metafeld sind sofort da: diese Verträge werden gezeigt, sobald sie
     geladen sind (onFirst), ohne auf die Liste der gültigen IDs von Appstle zu warten. Kommen dort weitere
     dazu, werden sie nachgeladen und die Ansicht ergänzt. */
  function loadAll(onFirst) {
    var started = {}, later = [];
    /* Reihenfolge: erst die Verträge und die Liste der gültigen IDs, danach die Details (Termine, Rhythmen).
       So stehen die wichtigen Aufrufe vorn, auch wenn der Browser nur wenige Verbindungen gleichzeitig öffnet. */
    var start = function (n, fb, now) {
      started[n] = fetchContract(n, fb);
      if (Object.keys(started).length <= 3) { if (now) startPrefetch(n); else later.push(n); } /* bei wenigen Abos Details sofort mitladen */
    };
    var settle = function () {
      /* Ein einzelner fehlgeschlagener Vertrag darf die anderen nicht blockieren */
      return Promise.all(Object.keys(started).map(function (k) { return started[k].then(null, function (err) { return { failed: err }; }); })).then(function (results) {
        var contracts = results.filter(function (r) { return r && !r.failed; });
        var failed = results.filter(function (r) { return r && r.failed; });
        if (!contracts.length && failed.length) throw failed[0].failed;
        /* Bereits angezeigte Details (aus dem Zwischenspeicher) stehen lassen, bis die frischen da sind */
        contracts.forEach(function (c) {
          var old = byId(c.id);
          if (!old || old === c) return;
          if (!c.attempts && old.attempts) { c.attempts = old.attempts; c.history = old.history; c.fulfillments = old.fulfillments; c.stale = true; }
          if (!c.frequencies && old.frequencies) { c.frequencies = old.frequencies; c.stale = true; }
        });
        state.contracts = sortContracts(contracts);
        state.error = null;
        /* Vorab geholte Details an die Verträge hängen (kein zusätzlicher Aufruf) */
        contracts.forEach(function (c) { if (prefetch[c.id]) loadDetailData(c); });
      });
    };
    (cfg.metafieldSubscriptions || []).forEach(function (m) { var n = num(m && m.id); if (n && !started[n]) start(n, m); });
    var valid = Appstle.validIds(cfg.customerId).then(function (res) {
      var added = false;
      unwrap(res).forEach(function (v) { var n = num(v && (v.id || v)); if (n && !started[n]) { start(n, null, true); added = true; } });
      return added;
    }, function () { return false; /* Metafeld reicht als Fallback */ });
    later.forEach(startPrefetch);
    if (!Object.keys(started).length) return valid.then(settle);
    return settle().then(function () { if (onFirst) onFirst(); }, function () {}).then(function () { return valid; }).then(function (added) {
      if (added || !state.contracts.length) return settle();
    });
  }

  /* Vertrag neu laden: Vertrag und Termine parallel, Rhythmen bleiben (bei Theme-Plänen neu zugeordnet) */
  function reloadContract(id) {
    return Promise.all([Appstle.contract(id), fetchAttempts(id)]).then(function (r) {
      var fresh = normalizeContract(r[0]);
      fresh.attempts = r[1].attempts; fresh.history = r[1].history; fresh.fulfillments = r[1].fulfillments;
      state.contracts = state.contracts.map(function (c) {
        if (c.id !== id) return c;
        fresh.frequencies = (c.frequencies && c.frequencies[0] && c.frequencies[0].source === 'liquid') ? liquidFrequencies(fresh) : c.frequencies;
        return fresh;
      });
      saveCache();
    });
  }
  /* --- Lieferstatus ---------------------------------------------------------
     Der Status eines Bestellversuchs sagt nur, ob die Abbuchung geklappt hat.
     Ob die Box unterwegs oder da ist, steht im Fulfillment der Bestellung.
     Appstle liefert es je nach Endpunkt unter verschiedenen Feldnamen, deshalb
     werden mehrere Schreibweisen geprueft. Ist nichts zu finden, bleibt der
     Status unbekannt und die Zeile behauptet keine Lieferung. */
  var ORDER_KEYS = ['orderId', 'orderID', 'order_id', 'shopifyOrderId', 'orderName', 'name', 'orderNumber'];
  /* Im verschachtelten order-Objekt heisst die Bestellung "id". Auf der obersten Ebene waere "id"
     dagegen die des Fulfillments und wuerde einen falschen Schluessel anlegen. */
  var ORDER_KEYS_NESTED = ['id'].concat(ORDER_KEYS);
  var FULFILL_KEYS = ['fulfillmentStatus', 'displayFulfillmentStatus', 'orderFulfillmentStatus', 'shipmentStatus', 'status', 'state'];

  /* Bestellung auf einen Schluessel bringen: "#1322" und gid://shopify/Order/1322 werden beide zu "1322". */
  function orderKey(v) {
    if (v == null || (typeof v !== 'string' && typeof v !== 'number')) return '';
    var t = String(v).trim();
    if (!t) return '';
    var m = t.match(/(\d+)\s*$/);
    return m ? m[1] : t.replace(/^#/, '').toUpperCase();
  }
  /* true = geliefert, false = noch nicht, null = unbekannt.
     UNFULFILLED enthaelt FULFILLED, deshalb zuerst auf die verneinenden Formen pruefen. */
  function fulfilledFlag(v) {
    var t = String(v == null ? '' : v).toUpperCase().replace(/[\s_-]/g, '');
    if (!t) return null;
    if (/UNFULFILLED|NOTFULFILLED|PARTIAL|PENDING|OPEN|SCHEDULED|INPROGRESS|ONHOLD|CANCEL|RESTOCK/.test(t)) return false;
    if (/FULFILLED|DELIVERED|COMPLETE/.test(t)) return true;
    return null;
  }
  /* Antwort des Fulfillment-Endpunkts auf { Bestellschluessel: true|false } bringen. */
  function fulfillmentMap(res) {
    var list = unwrap(res);
    if (!list.length && res && typeof res === 'object' && !Array.isArray(res)) list = [res];
    var map = {};
    list.forEach(function (e) {
      if (!e || typeof e !== 'object') return;
      var flag = null;
      FULFILL_KEYS.forEach(function (k) { if (flag === null) flag = fulfilledFlag(e[k]); });
      if (flag === null) return;
      var quellen = [[e, ORDER_KEYS]];
      if (e.order && typeof e.order === 'object') quellen.push([e.order, ORDER_KEYS_NESTED]);
      quellen.forEach(function (q) {
        q[1].forEach(function (k) {
          var key = orderKey(q[0][k]);
          if (key) map[key] = flag;
        });
      });
    });
    return map;
  }
  /* Lieferstatus einer Zeile: erst das, was am Bestellversuch selbst haengt, dann die Fulfillment-Liste. */
  function attemptFulfilled(c, h) {
    var eigen = fulfilledFlag(h.fulfillment);
    if (eigen !== null) return eigen;
    var map = c && c.fulfillments;
    if (!map) return null;
    var keys = [orderKey(h.orderId), orderKey(h.orderName)];
    for (var i = 0; i < keys.length; i += 1) {
      if (keys[i] && map[keys[i]] != null) return map[keys[i]];
    }
    return null;
  }

  /* Appstle-Bestellversuch auf die Felder bringen, die das Portal braucht (Doku: id, status, billingDate, orderName, orderAmount) */
  function normAttempt(a) {
    a = a || {};
    return {
      id: a.id != null ? a.id : (a.billingAttemptId || a.attemptId),
      status: String(a.status || a.billingAttemptStatus || a.attemptStatus || '').toUpperCase(),
      billingDate: a.billingDate || a.nextBillingDate || a.billingDateTime || a.date || null,
      attemptTime: a.attemptTime || null, orderName: a.orderName, orderAmount: a.orderAmount,
      orderId: a.orderId != null ? a.orderId : (a.orderID != null ? a.orderID : (a.shopifyOrderId != null ? a.shopifyOrderId : null)),
      /* Falls past-orders den Fulfillment-Status schon mitliefert, spart das den Zusatzaufruf. */
      fulfillment: a.fulfillmentStatus || a.orderFulfillmentStatus || a.displayFulfillmentStatus || null,
      raw: a
    };
  }
  function fetchAttempts(id) {
    var up = Appstle.upcoming(id).then(function (res) {
      if (DEBUG) state.debugRaw.topOrders = JSON.stringify(res).slice(0, 400);
      return unwrap(res).map(normAttempt);
    }, function (err) { state.debugRaw.topOrders = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return null; });
    var past = Appstle.past(id).then(function (res) {
      if (DEBUG) state.debugRaw.pastOrders = JSON.stringify(res).slice(0, 400);
      return unwrap(res).map(normAttempt);
    }, function (err) { state.debugRaw.pastOrders = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return null; });
    /* Scheitert der Fulfillment-Aufruf, bleibt die Karte leer und die Zeilen sagen
       "Bezahlt, Lieferung folgt". Eine Lieferung wird nie behauptet. */
    var ff = Appstle.fulfillments(id).then(function (res) {
      if (DEBUG) state.debugRaw.fulfillments = JSON.stringify(res).slice(0, 400);
      return fulfillmentMap(res);
    }, function (err) { state.debugRaw.fulfillments = 'Fehler ' + (err && err.status) + ' ' + (err && err.message); return {}; });
    return Promise.all([up, past, ff]).then(function (r) { return { attempts: r[0] || [], history: r[1] || [], fulfillments: r[2] || {} }; });
  }
  function cleanName(n) { return String(n || '').replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim(); }
  function liquidFrequencies(c) {
    var cur = c.box && boxVariants[c.box.variantId];
    var plans = (cur && cur.plans) || [];
    if (!plans.length) return [];
    var curPlan = num(c.box.sellingPlanId);
    /* Nur die Verkaufsplan-Gruppe anbieten, in der das Abo läuft; sonst die Appstle-Gruppe; sonst die erste */
    var group = null;
    plans.forEach(function (p) { if (curPlan && num(p.id) === curPlan) group = p.groupId; });
    if (!group) { var ap = plans.filter(function (p) { return /appstle/i.test(p.appId || ''); }); group = (ap[0] || plans[0]).groupId; }
    var list = plans.filter(function (p) { return p.groupId === group; });
    list.sort(function (a, b) { return (num(a.id) === curPlan ? 0 : 1) - (num(b.id) === curPlan ? 0 : 1); }); /* gebuchten Plan bei Duplikaten behalten */
    var curLabel = cleanName(rhythmLabel(c.billingPolicy || c.deliveryPolicy)).toLowerCase();
    var firstIdx = {};
    plans.forEach(function (p, i) { var k = cleanName(p.name).toLowerCase(); if (!(k in firstIdx)) firstIdx[k] = i; });
    var seen = {}, out = [];
    list.forEach(function (p) {
      var name = cleanName(p.name), key = name.toLowerCase();
      if (!name || seen[key]) return; seen[key] = p;
      /* aktiv = gebuchter Plan; kennt der Vertrag keine Plan-ID, zählt der passende Rhythmus-Name */
      var act = curPlan ? num(p.id) === curPlan : key === curLabel;
      out.push({ sellingPlanId: num(p.id), name: name, selected: act, source: 'liquid', order: firstIdx[key] });
    });
    out.sort(function (a, b) { return a.order - b.order; });
    return out;
  }

  /* ---------- Rendering: Bausteine ---------- */
  function badge(variant, text, extraClass) {
    return '<span class="frp-badge frp-badge--' + variant + (extraClass ? ' ' + extraClass : '') + '">' + esc(text) + '</span>';
  }
  function btn(variant, label, action, data, extraClass, gesperrt) {
    var attrs = '';
    Object.keys(data || {}).forEach(function (k) { attrs += ' data-' + k + '="' + esc(data[k]) + '"'; });
    if (gesperrt) attrs += ' disabled title="Diese Lieferung ist schon in Vorbereitung."';
    return '<button type="button" class="frp-btn frp-btn--' + variant + (extraClass ? ' ' + extraClass : '') + '" data-action="' + esc(action) + '"' + attrs + '>' + esc(label) + '</button>';
  }

  function kgFmt(k) { return Number(k).toFixed(1).replace('.', ','); }

  /* Datenquelle der Statistik. Liquid stellt customer.orders auf einer normalen Seite nicht bereit, die Liste
     kommt dort leer an und die Karte blendete sich aus. Ersatzweise wird aus den tatsaechlich gelieferten
     Boxen der Appstle-Vertraege gerechnet. Ist am Produkt ein Gewicht hinterlegt, wird damit gerechnet,
     sonst mit dem Durchschnittsgewicht je Box aus den Section-Einstellungen. */
  function statsOrders() {
    if ((cfg.orders || []).length) return cfg.orders;
    var out = [];
    (state.contracts || []).forEach(function (c) {
      /* Nur Box-Positionen zaehlen. Extras sind Einmal-Zugaben und keine Boxen; wuerden sie
         mitzaehlen, stuende bei einer Box mit zwei Extras das Dreifache in der Statistik. Erkannt werden sie
         positiv an den bekannten Box-Varianten: das Kennzeichen isExtra stammt aus der Extras-Kollektion, die
         oft gar nicht gesetzt ist, und deckt je Produkt nur eine Variante ab. */
      var lines = c.lines || [];
      var boxLines = lines.filter(function (l) { return boxVariants[l.variantId]; });
      if (!boxLines.length) boxLines = lines.filter(function (l) { return l.sellingPlanId && !l.isExtra; });
      if (!boxLines.length) boxLines = lines.filter(function (l) { return !l.isExtra; });
      var qty = boxLines.reduce(function (n, l) { return n + (Number(l.quantity) || 0); }, 0) || 1;
      /* Am Produkt hinterlegtes Gewicht je Box, sonst faellt renderStats auf das Durchschnittsgewicht
         aus den Section-Einstellungen zurueck. */
      var grams = 0;
      boxLines.forEach(function (l) {
        var b = boxVariants[l.variantId];
        if (b && Number(b.grams) > 0) grams += Number(b.grams) * (Number(l.quantity) || 1);
      });
      pastAttempts(c).forEach(function (a) {
        if (String(a.status || '').toUpperCase() !== 'SUCCESS') return;
        var d = parseDate(a.billingDate || a.attemptTime);
        if (!d) return;
        out.push({ date: d, grams: grams, boxes: qty, cancelled: false });
      });
    });
    return out;
  }

  function renderStats() {
    if (!cfg.showStats) return '';
    var orders = statsOrders().filter(function (o) { return !o.cancelled; });
    var kg = 0, first = null, year = new Date().getFullYear(), byMonth = {};
    orders.forEach(function (o) {
      var d = parseDate(o.date); if (!d) return;
      var w = o.grams > 0 ? o.grams / 1000 : (o.boxes || 1) * Number(cfg.avgBoxKg || 5);
      kg += w;
      if (!first || d < first) first = d;
      if (d.getFullYear() === year) byMonth[d.getMonth()] = (byMonth[d.getMonth()] || 0) + w;
    });
    if (cfg.totalKgOverride != null && !isNaN(Number(cfg.totalKgOverride))) kg = Number(cfg.totalKgOverride);
    /* Die Karte bleibt auch bei null stehen: der Zaehler soll von Anfang an sichtbar sein. */
    var zero = !orders.length && !kg;
    /* Die Anzahl kommt aus denselben Positionen wie die Kilo (ohne stornierte Bestellungen und Einmalkaeufe). */
    var count = orders.reduce(function (n, o) { return n + (Number(o.boxes) || 1); }, 0);
    var months = Object.keys(byMonth).map(Number).sort(function (a, b) { return a - b; });
    var max = months.reduce(function (m, k) { return Math.max(m, byMonth[k]); }, 0) || 1;
    var chart = '';
    if (months.length) {
      chart = '<div class="frp-chart__title">Dein fruvi-Jahr ' + year + '</div><div class="frp-chart">' + months.map(function (m, i) {
        var h = Math.max(4, Math.round(byMonth[m] / max * 56));
        return '<div class="frp-chart__col" title="' + esc(kgFmt(byMonth[m]) + ' kg Obst und Gemüse') + '"><div class="frp-chart__bar' + (i === months.length - 1 ? ' frp-chart__bar--current' : '') + '" style="height:' + h + 'px"></div><div class="frp-chart__label">' + MON_XS[m] + '</div></div>';
      }).join('') + '</div>';
    }
    var portions = Math.round(kg * Number(cfg.portionsPerKg || 8));
    var compare = [];
    if (portions > 0) compare.push('≈ ' + portions.toLocaleString('de-DE') + ' Portionen Obst und Gemüse');
    if (Number(cfg.statsFarms) > 0) compare.push(cfg.statsFarms + ' Höfe aus der Region');
    var since = first ? MONTHS[first.getMonth()] + ' ' + first.getFullYear() : null;
    var name = zero
      ? (cfg.customerFirstName ? 'Gleich geht es los, ' + cfg.customerFirstName + '.' : 'Gleich geht es los.')
      : (cfg.customerFirstName ? 'Schön, ' + cfg.customerFirstName + '.' : 'Schön.');
    var sub = zero
      ? 'Ab deiner ersten Lieferung zählen wir hier mit, wie viel Obst und Gemüse bei dir angekommen ist.'
      : count > 0
        ? count + (count === 1 ? ' Box' : ' Boxen') + ' frisch vom Hof' + (since ? ', seit ' + since : '') + '.'
        : 'Frisch vom Hof, direkt zu dir nach Hause.';
    return '<div class="frp-card frp-card--inverse frp-card--clip frp-stats">' +
      '<div class="frp-stats__inner"><div class="frp-stats__left">' +
      '<div><span class="frp-badge frp-badge--orange">Deine Bilanz</span>' +
      '<div class="frp-stats__headline">' + esc(kgFmt(kg)) + ' kg obst &amp; gemüse.<br>' + esc(name) + '</div>' +
      '<p class="frp-stats__sub">' + esc(sub) + '</p></div>' +
      '</div>' +
      (chart || compare.length ? '<div class="frp-stats__right">' + chart + (compare.length ? '<div class="frp-stats__compare">' + esc(compare.join(' · ')) + '</div>' : '') + '</div>' : '') +
      '</div></div>';
  }

  function renderSeason() {
    var m = new Date().getMonth() + 1;
    var raw = (cfg.season || {})[m];
    if (!raw) return '';
    var split = function (v) { return String(v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    var groups = [
      { title: 'Neu dabei', cls: 'neu', items: split(raw.neu) },
      { title: 'Mitten in der Saison', cls: 'saison', items: split(raw.saison) },
      { title: 'Bald vorbei', cls: 'bald', items: split(raw.bald) }
    ].filter(function (g) { return g.items.length; });
    if (!groups.length) return '';
    return '<div class="frp-card frp-card--tip frp-season"><div class="frp-season__head"><h2 class="frp__h2 frp__h2--sm">gerade in saison.</h2><span class="frp-badge frp-badge--inverse">' + MONTHS[m - 1] + '</span></div>' +
      '<p class="frp-small frp-muted frp-season__lead">Was davon in deiner Box landet, entscheidet die Ernte der Woche.</p>' +
      '<div class="frp-season__grid">' + groups.map(function (g) {
        return '<div class="frp-season__group frp-season__group--' + g.cls + '"><div class="frp-season__label"><span class="frp-season__dot"></span>' + esc(g.title) + '</div>' +
          '<div class="frp-chips">' + g.items.map(function (v) { return '<span class="frp-chip">' + esc(v) + '</span>'; }).join('') + '</div></div>';
      }).join('') + '</div></div>';
  }

  function renderOverview() {
    var cs = state.contracts;
    var html = headerHtml('Hallo ' + (cfg.customerFirstName || 'du') + ', schön, dass du da bist.');
    html += renderStats();
    if (!cs.length) {
      html += '<div class="frp-card frp-empty"><h2 class="frp__h2 frp__h2--sm">Noch kein Abo am Start.</h2><p class="frp-small frp-muted">Sobald du eine Box abonniert hast, verwaltest du hier Liefertermine und Extras.</p><div class="frp-actions"><a class="frp-btn frp-btn--cta" href="' + esc(cfg.newSubscriptionUrl) + '">Box aussuchen</a></div></div>';
    } else {
      html += '<div class="frp-subs">' + cs.map(function (c) {
        var b = statusBadge(c, true);
        var rhythm = rhythmLabel(c.billingPolicy || c.deliveryPolicy);
        var boxLine = [boxTitle(c) + (boxSize(c) ? ' (' + boxSize(c) + ')' : ''), rhythm, boxPrice(c) ? money(boxPrice(c)) : ''].filter(Boolean).join(' · ');
        var del = deliveryDate(c);
        var statusLine = c.status === 'ACTIVE' ? 'Nächste Lieferung: ' + fmtShort(del) + (c.nextBillingDate ? ' · Abrechnung: ' + c.nextBillingDate.getDate() + '. ' + MON_S[c.nextBillingDate.getMonth()] : '')
          : c.status === 'PAUSED' ? 'Pausiert – du bestimmst, wann es weitergeht'
          : c.status === 'FAILED' ? 'Die letzte Abbuchung hat nicht geklappt – bitte Zahlart prüfen.'
          : 'Beendet – schön, dass du dabei warst.';
        var gek = c.status === 'CANCELLED' || c.status === 'EXPIRED';
        var bv = c.box && boxVariants[c.box.variantId];
        var img = bv && bv.image ? '<img class="frp-sub__img" src="' + esc(bv.image) + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '';
        return '<div class="frp-card frp-sub frp-actionable' + (img ? ' frp-sub--img' : '') + '" data-action="open" data-id="' + c.id + '" role="button" tabindex="0">' + img +
          '<div class="frp-sub__main"><div class="frp-sub__title"><span class="frp-sub__label">' + esc(boxTitle(c)) + '</span>' + badge(b[0], b[1]) + '</div>' +
          '<div class="frp-small frp-strong">' + esc(boxLine) + '</div>' +
          '<div class="frp-small frp-muted">' + esc(statusLine) + '</div>' +
          (addressLine(c) ? '<div class="frp-xs frp-muted">' + esc(addressLine(c)) + '</div>' : '') +
          '</div><div class="frp-sub__actions">' +
          (gek ? btn('cta', 'Reaktivieren', 'reactivate', { id: c.id }, 'frp-btn--sm') : '') +
          btn('secondary', 'Verwalten', 'open', { id: c.id }, 'frp-btn--sm') +
          '</div></div>';
      }).join('') + '</div>';
      html += '<p class="frp-more">Noch eine Adresse zu beliefern? <a href="' + esc(cfg.newSubscriptionUrl) + '">Weiteres Abo starten</a></p>';
    }
    html += renderSeason();
    return html;
  }

  function renderDetail(c) {
    var b = statusBadge(c, false);
    var active = c.status === 'ACTIVE' || c.status === 'FAILED';
    /* Bestellschluss gilt nur fuer laufende Abos. Bei einem pausierten Vertrag steht
       keine Lieferung an, da darf nichts gesperrt sein. */
    var zu = active && aboGesperrt(c);
    var kuendZu = zu && cfg.cutoffLockCancel !== false;
    var paused = c.status === 'PAUSED';
    var gek = c.status === 'CANCELLED' || c.status === 'EXPIRED';
    var del = deliveryDate(c);
    var ex = extrasFor(c);
    var html = '';
    html += '<button type="button" class="frp-btn--link" data-action="back" style="margin-bottom:16px">' + ICON.back + '<span>Alle Abos</span></button>';
    /* Kopf bewusst knapp: Box-Name als Titel, Größe als Untertitel – Adresse und Rhythmus stehen in den Karten darunter */
    var hv = c.box && boxVariants[c.box.variantId];
    var himg = hv && hv.image ? '<img class="frp__header-img" src="' + esc(hv.image) + '" alt="" width="64" height="64" loading="lazy" decoding="async">' : '';
    /* Status-Badge sitzt über dem Titel, bündig mit Titel und Größe – links daneben das Box-Bild */
    html += '<header class="frp__header frp__header--detail"><div class="frp__header-main">' + himg + '<div class="frp__header-text">' + badge(b[0], b[1], 'frp-badge--sm') +
      '<h1 class="frp__h1">' + esc(boxTitle(c)) + '</h1>' + (boxSize(c) ? '<p class="frp__lead">' + esc(boxSize(c)) + '</p>' : '') + '</div></div></header>';
    html += '<nav class="frp-nav">' +
      (active ? '<a href="#frp-naechste">Nächste Lieferung</a>' + (ex.length ? '<a href="#frp-extras">Extras</a>' : '') + '<a href="#frp-abo">Abo verwalten</a>' : '') +
      '<a href="#frp-adresse">Adresse &amp; Zahlung</a><a href="#frp-historie">Bisherige Bestellungen</a></nav>';

    if (paused) {
      html += '<div class="frp-card frp-card--tip frp-banner frp-actionable"><div><h2 class="frp__h2 frp__h2--sm">Dieses Abo ist pausiert.</h2><p class="frp-small">Keine Lieferungen und keine Abbuchungen, bis du es hier wieder startest. Die nächste Box kommt dann zum nächsten regulären Termin.</p></div>' +
        '<div class="frp-banner__actions">' + btn('cta', 'Jetzt fortsetzen', 'resume', { id: c.id }) + btn('ghost', 'Abo kündigen', 'open-cancel', { id: c.id }) + '</div></div>';
    }
    if (gek) {
      html += '<div class="frp-card frp-card--inverse frp-banner frp-actionable"><div><h2 class="frp__h2 frp__h2--sm">Dieses Abo ist gekündigt.</h2><p class="frp-small">Wir freuen uns, wenn du wieder dabei bist.</p></div>' +
        btn('cta', 'Abo reaktivieren', 'reactivate', { id: c.id }) + '</div>';
    }
    if (c.status === 'FAILED') {
      html += '<div class="frp-card frp-card--tip frp-banner frp-actionable"><div><h2 class="frp__h2 frp__h2--sm">Die Abbuchung hat nicht geklappt.</h2><p class="frp-small">Prüfe deine Zahlart, dann läuft die nächste Lieferung wieder wie gewohnt.</p></div>' +
        btn('cta', 'Zahlart ändern', 'payment', { id: c.id }) + '</div>';
    }

    if (active) {
      var na = nextAttempt(c);
      var nextBilling = na ? parseDate(na.billingDate) : c.nextBillingDate;
      var nextDel = deliveryDate(c, nextBilling);
      var extrasCount = c.extras.reduce(function (t, l) { return t + l.quantity; }, 0);
      var extrasTotal = c.extras.reduce(function (t, l) { return t + l.lineTotal; }, 0);
      html += '<section id="frp-naechste" class="frp-section"><h2 class="frp__h2">Nächste Lieferung</h2>' +
        '<div class="frp-card frp-card--clip frp-next frp-actionable">' +
        '<div class="frp-next__info"><div class="frp-next__date">' + esc(fmtLong(nextDel)) + '</div>' +
        (nextBilling ? '<div class="frp-xs frp-muted">Nächste Abrechnung: ' + esc(fmtLong(nextBilling)) + '</div>' : '') +
        '<div class="frp-badges">' + (rhythmLabel(c.billingPolicy || c.deliveryPolicy) ? badge('yellow', rhythmLabel(c.billingPolicy || c.deliveryPolicy)) : '') + (c.deliveryDay ? badge('yellow', c.deliveryDay) : '') + '</div>' +
        (addressLine(c) ? '<div class="frp-meta">' + ICON.pin + '<span>' + esc(addressLine(c)) + '</span></div>' : '') +
        (ex.length ? '<div class="frp-meta">' + ICON.box + '<span>' + esc(extrasCount ? extrasCount + ' Extra' + (extrasCount > 1 ? 's' : '') + ' dabei (' + money(extrasTotal) + ')' : 'Noch keine Extras dabei') + '</span></div>' : '') +
        '</div><div class="frp-next__actions">' + btn('secondary', 'Diese Lieferung überspringen', 'skip-next', { id: c.id }, '', zu) +
        (ex.length && !zu ? '<a class="frp-btn frp-btn--cta" href="#frp-extras">Extras hinzufügen</a>' : '') + '</div></div>';
      if (zu) {
        html += '<div class="frp-card frp-card--tip frp-banner frp-banner--sm"><div><p class="frp-small frp-strong">Diese Box ist schon in Vorbereitung.</p>' +
          '<p class="frp-xs frp-muted">Ab ' + cutoffTage() + ' Tagen vor der Lieferung steht der Inhalt fest. Änderungen an Box, Rhythmus und Extras wirken ab der Lieferung danach. Lieferadresse und Zahlart kannst du weiterhin ändern.</p></div></div>';
      }

      var qa = queuedAttempts(c);
      var skipped = qa.filter(function (a) { return String(a.status).toUpperCase() === 'SKIPPED'; });
      html += '<h3 class="frp__h3">Die nächsten Wochen</h3>';
      if (skipped.length) {
        var lastSkip = deliveryDate(c, parseDate(skipped[skipped.length - 1].billingDate));
        html += '<div class="frp-card frp-card--tip frp-banner frp-banner--sm frp-actionable"><div><p class="frp-small frp-strong">' +
          esc(skipped.length === 1 ? 'Du setzt eine Lieferung aus (' + fmtShort(lastSkip) + ')' : 'Du setzt ' + skipped.length + ' Lieferungen aus (bis ' + fmtShort(lastSkip) + ')') +
          '</p><p class="frp-xs frp-muted">Nächste Box: ' + esc(fmtShort(nextDel)) + ' – einzelne Wochen kannst du unten wieder aktivieren.</p></div>' +
          btn('secondary', skipped.length === 1 ? 'Wieder liefern' : 'Pause beenden – alle wieder liefern', 'unskip-all', { id: c.id }, 'frp-btn--sm', zu) + '</div>';
      }
      html += '<div class="frp-card frp-card--md frp-list frp-actionable">';
      if (c.attempts === null) {
        html += '<div class="frp-row"><div class="frp-loading"><span class="frp-spinner"></span><span>Termine laden …</span></div></div>';
      } else if (!qa.length) {
        html += '<div class="frp-row"><span class="frp-small frp-muted">Noch keine geplanten Termine hinterlegt.</span></div>';
      } else {
        html += qa.slice(0, PAUSE_MAX).map(function (a) {
          var sk = String(a.status).toUpperCase() === 'SKIPPED';
          var d = deliveryDate(c, parseDate(a.billingDate));
          /* Nur die Termine im Bestellschluss sperren. Spaetere Wochen bleiben frei,
             sonst waere die ganze Liste tot, sobald die naechste Box ansteht. */
          var rowZu = terminGesperrt(d);
          return '<div class="frp-row"><div class="frp-row__main">' + ICON.cal + '<span class="frp-row__label' + (sk ? ' is-skipped' : '') + '">' + esc(fmtShort(d)) + '</span>' + (sk ? badge('orange', 'Übersprungen', 'frp-badge--sm') : '') + '</div>' +
            (rowZu ? badge('yellow', 'In Vorbereitung', 'frp-badge--sm')
                   : btn('ghost', sk ? 'Wieder liefern' : 'Überspringen', sk ? 'unskip' : 'skip', { id: c.id, attempt: a.id }, 'frp-btn--sm')) + '</div>';
        }).join('');
      }
      html += '<p class="frp-list__note">Übersprungene Wochen werden nicht berechnet. Umbuchen geht bis ' + (cutoffTage() ? cutoffTage() + ' Tage vor der Lieferung – danach ist die Box in Vorbereitung' : 'zur Abrechnung') + '.</p></div></section>';

      if (ex.length) {
        html += '<section id="frp-extras" class="frp-section"><div class="frp-section__head"><h2 class="frp__h2">Extras für deine Box</h2>' + badge('yellow', 'Gilt nur für die nächste Lieferung') + '</div>' +
          '<p class="frp-section__lead">Kommt einfach mit in deine nächste Box.</p><div class="frp-extras frp-actionable">';
        html += ex.map(function (p) {
          var line = c.extras.filter(function (l) { return l.variantId === p.id; })[0];
          var q = line ? line.quantity : 0;
          return '<div class="frp-card frp-extra">' + (p.image ? '<div class="frp-extra__img"><img src="' + esc(p.image) + '" alt="" loading="lazy"></div>' : '') +
            '<div><div class="frp-extra__name">' + esc(p.name) + '</div>' + (p.detail ? '<div class="frp-small frp-muted">' + esc(p.detail) + '</div>' : '') + '</div>' +
            '<div class="frp-extra__foot"><span class="frp-strong">' + esc(money(p.price)) + '</span>' +
            (q > 0 ? '<div class="frp-qty"><button type="button" class="frp-qty__btn frp-qty__btn--minus" data-action="extra-dec" data-id="' + c.id + '" data-variant="' + p.id + '" aria-label="Weniger"' + (zu ? ' disabled' : '') + '>−</button><span class="frp-qty__num">' + q + '</span><button type="button" class="frp-qty__btn frp-qty__btn--plus" data-action="extra-inc" data-id="' + c.id + '" data-variant="' + p.id + '" aria-label="Mehr"' + (zu ? ' disabled' : '') + '>+</button></div>'
              : (p.available === false ? badge('orange', 'Ausverkauft', 'frp-badge--sm') : btn('primary', '+ Dazu', 'extra-inc', { id: c.id, variant: p.id }, 'frp-btn--sm', zu))) +
            '</div></div>';
        }).join('') + '</div>';
        if (extrasCount) html += '<div class="frp-extras__summary">' + esc(extrasCount + ' Extra' + (extrasCount > 1 ? 's' : '') + ' · ' + money(extrasTotal) + ' – kommt zu deiner Lieferung am ' + fmtShort(nextDel) + ' dazu.') + '</div>';
        html += '</section>';
      }

      html += '<section id="frp-abo" class="frp-section"><h2 class="frp__h2">Abo verwalten</h2><div class="frp-card frp-manage frp-actionable">';
      var boxOpts = (cfg.boxes || []).filter(function (x) { return x.available !== false || (c.box && x.id === c.box.variantId); });
      if (boxOpts.length > 1 && c.box) {
        /* Stufe 1: ein Kärtchen je Hauptprodukt – Stufe 2: die Größen des aufgeklappten Produkts */
        var cur = boxVariants[c.box.variantId];
        var groups = [], byProd = {};
        boxOpts.forEach(function (x) {
          if (!byProd[x.productId]) { byProd[x.productId] = { productId: x.productId, product: x.product, image: null, variants: [] }; groups.push(byProd[x.productId]); }
          if (!byProd[x.productId].image && x.image) byProd[x.productId].image = x.image;
          byProd[x.productId].variants.push(x);
        });
        groups.forEach(function (g) { g.variants.sort(function (a, b) { return a.price - b.price; }); });
        var curPid = cur ? cur.productId : null;
        /* Die gebuchte Box steht immer vorn, danach aufsteigend nach dem günstigsten Preis des Produkts */
        var minPrice = function (g) { return Math.min.apply(null, g.variants.map(function (v) { return v.price; })); };
        groups.sort(function (a, b) {
          var ac = a.productId === curPid ? 0 : 1, bc = b.productId === curPid ? 0 : 1;
          return ac !== bc ? ac - bc : minPrice(a) - minPrice(b);
        });
        var openPid = (state.boxProduct && byProd[state.boxProduct]) ? state.boxProduct : (curPid && byProd[curPid] ? curPid : groups[0].productId);
        html += '<div><div class="frp-manage__title">Deine Box</div><p class="frp-small frp-muted frp-boxes__hint">Tippe auf eine Box, um die Größen zu sehen.</p><div class="frp-boxes">' + groups.map(function (g) {
          var isCur = g.productId === curPid, isOpen = g.productId === openPid;
          var prices = g.variants.map(function (v) { return v.price; });
          var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
          var sub = g.variants.length > 1 ? g.variants.length + ' Größen · ' + (min === max ? money(min) : 'ab ' + money(min)) : (g.variants[0].variant ? g.variants[0].variant + ' · ' : '') + money(min);
          return '<button type="button" class="frp-box' + (g.image ? ' frp-box--img' : '') + (isOpen ? ' is-active' : '') + (isCur ? ' is-current' : '') + '" data-action="pick-product" data-id="' + c.id + '" data-product="' + g.productId + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '">' +
            (g.image ? '<img class="frp-box__img" src="' + esc(g.image) + '" alt="" width="72" height="72" loading="lazy" decoding="async">' : '') +
            '<span class="frp-box__body"><span class="frp-box__name">' + esc(g.product) + '</span>' +
            (isCur ? '<span class="frp-box__desc">Deine aktuelle Box' + (cur && cur.variant ? ' · ' + esc(cur.variant) : '') + '</span>' : '') +
            '<span class="frp-box__price">' + esc(sub) + '</span></span></button>';
        }).join('') + '</div>';
        var og = byProd[openPid];
        if (og) {
          html += '<div class="frp-sizes"><div class="frp-sizes__title">' + esc(og.product) + ': Größe wählen</div><div class="frp-sizes__list">' + og.variants.map(function (x) {
            var act = c.box.variantId === x.id;
            return '<button type="button" class="frp-size' + (act ? ' is-active' : '') + '" data-action="pick-box" data-id="' + c.id + '" data-variant="' + x.id + '"' + (act ? ' aria-pressed="true"' : '') + ((zu && !act) ? ' disabled' : '') + '>' +
              '<span class="frp-size__name">' + esc(x.variant || 'Standard') + '</span>' +
              '<span class="frp-size__price">' + esc(money(x.price)) + ' / Lieferung</span>' +
              (act ? '<span class="frp-size__tag">Aktuell</span>' : '') + '</button>';
          }).join('') + '</div></div>';
        }
        html += '</div>';
      }
      var freqs = c.frequencies || [];
      html += '<div><div class="frp-manage__title">Lieferrhythmus</div>';
      if (c.frequencies === null) {
        html += '<div class="frp-small frp-muted">Optionen laden …</div>';
      } else if (freqs.length) {
        html += '<div class="frp-pills">' + freqs.map(function (f, i) {
          var label = freqLabel(f);
          var act = istAktiverRhythmus(c, f);
          return '<button type="button" class="frp-pill' + (act ? ' is-active' : '') + '" data-action="pick-frequency" data-id="' + c.id + '" data-index="' + i + '"' + ((zu && !act) ? ' disabled' : '') + '>' + esc(label) + '</button>';
        }).join('') + '</div>';
      } else {
        html += '<div class="frp-pills"><span class="frp-pill is-active">' + esc(rhythmLabel(c.billingPolicy || c.deliveryPolicy) || 'Wie gebucht') + '</span></div><p class="frp-xs frp-muted" style="margin-top:8px">Für diese Box ist aktuell nur ein Rhythmus verfügbar.</p>';
      }
      html += '</div>' + (zu ? '<p class="frp-xs frp-muted frp-manage__hint">Deine nächste Box ist in Vorbereitung. Änderungen hier wirken ab der Lieferung danach.'
          + (kuendZu ? ' Kündigen kannst du, sobald die Box unterwegs ist – oder jederzeit formlos per Mail an <a href="mailto:' + esc(cfg.shopEmail || 'hello@fruvi.de') + '">' + esc(cfg.shopEmail || 'hello@fruvi.de') + '</a>.' : '')
          + '</p>' : '') +
        '<div class="frp-manage__foot">' + btn('secondary', 'Lieferungen aussetzen', 'open-pause', { id: c.id }, '', zu) + btn('ghost', 'Abo kündigen', 'open-cancel', { id: c.id }, '', kuendZu) + '</div></div></section>';
    }

    var a = c.address;
    var name = [a.firstName, a.lastName].filter(Boolean).join(' ') || a.company;
    html += '<section id="frp-adresse" class="frp-section"><h2 class="frp__h2">Adresse &amp; Zahlung</h2><div class="frp-grid2 frp-actionable">' +
      '<div class="frp-card frp-info"><div class="frp-info__title">' + ICON.pinMd + '<span>Lieferadresse</span></div>' +
      '<div class="frp-info__body">' + (name ? esc(name) + '<br>' : '') + (a.company && name !== a.company ? esc(a.company) + '<br>' : '') + esc(a.address1) + (a.address2 ? ', ' + esc(a.address2) : '') + '<br>' + esc([a.zip, a.city].filter(Boolean).join(' ')) + '</div>' +
      (c.note ? '<div class="frp-xs frp-muted">Hinweis für die Zustellung: ' + esc(c.note) + '</div>' : '') +
      (gek ? '' : '<div>' + btn('secondary', 'Bearbeiten', 'open-address', { id: c.id }, 'frp-btn--sm') + '</div>') + '</div>' +
      '<div class="frp-card frp-info"><div class="frp-info__title">' + ICON.card + '<span>Zahlart</span></div>' +
      '<div class="frp-info__body">' + (c.payment ? esc(c.payment.brand ? c.payment.brand.charAt(0).toUpperCase() + c.payment.brand.slice(1).toLowerCase() : 'Karte') + (c.payment.last4 ? ' •••• ' + esc(c.payment.last4) : '') + (c.payment.month ? '<br>Gültig bis ' + esc(('0' + c.payment.month).slice(-2) + '/' + String(c.payment.year).slice(-2)) : '') : 'Hinterlegte Zahlart') + '</div>' +
      '<div class="frp-xs frp-muted">Abgerechnet wird ' + (cfg.deliveryOffsetDays ? cfg.deliveryOffsetDays + ' Tage vor jeder Lieferung' : 'am Liefertag') + '.</div>' +
      (gek ? '' : '<div>' + btn('secondary', 'Zahlart ändern', 'payment', { id: c.id }, 'frp-btn--sm') + '</div>') + '</div></div></section>';

    html += '<section id="frp-historie" class="frp-section"><h2 class="frp__h2">Bisherige Bestellungen</h2><div class="frp-card frp-card--md frp-list">';
    if (c.history === null) {
      html += '<div class="frp-row"><div class="frp-loading"><span class="frp-spinner"></span><span>Bestellungen laden …</span></div></div>';
    } else if (!pastAttempts(c).length) {
      html += '<div class="frp-row"><span class="frp-small frp-muted">Noch keine Bestellung – die erste kommt bald.</span></div>';
    } else {
      html += pastAttempts(c).slice(0, 12).map(function (h) {
        var s = String(h.status || '').toUpperCase();
        /* SUCCESS meldet Appstle fuer den Zahlungsversuch, nicht fuer die Zustellung. Appstle weiss
           vom Liefern nichts. "Geliefert" stand hier also an einem Tag, an dem die Box noch gar nicht
           unterwegs war. Der Abrechnungstag liegt cfg.deliveryOffsetDays Tage vor der Lieferung. */
        var geliefert = s === 'SUCCESS' ? attemptFulfilled(c, h) : null;
        var map = s === 'SKIPPED' ? ['orange', 'Übersprungen']
          : (s === 'FAILURE' || s === 'FAILED') ? ['orange', 'Zahlung fehlgeschlagen']
          : s === 'SUCCESS' ? (geliefert === true ? ['green', 'Geliefert'] : ['yellow', 'Bezahlt, Lieferung folgt'])
          : ['yellow', 'Geplant'];
        /* Abrechnungstag, nicht Liefertag. Abrechnung plus Offset trifft nur die Folgebestellungen;
           bei der ersten waehlt der Kunde seinen Liefertag frei, da lagen bis zu sieben Tage dazwischen. */
        var d = parseDate(h.billingDate || h.attemptTime);
        var detail = s === 'SKIPPED' ? 'Übersprungen' : boxTitle(c) + (h.orderName ? ' · Bestellung ' + h.orderName : '');
        /* 0,00 EUR meldet Appstle auch fuer Bestellungen, die es nicht selbst angelegt hat,
           etwa die erste aus dem Shop. Lieber kein Betrag als eine falsche Null. */
        var total = s === 'SKIPPED' ? money(0) : (Number(h.orderAmount) > 0 ? money(h.orderAmount) : '');
        return '<div class="frp-row"><div><div class="frp-row__label">' + esc(fmtShort(d)) + '</div><div class="frp-small frp-muted">' + esc(detail) + '</div></div>' +
          '<div class="frp-row__side">' + (total ? '<span class="frp-strong frp-small">' + esc(total) + '</span>' : '') + badge(map[0], map[1], 'frp-badge--sm') + '</div></div>';
      }).join('');
    }
    html += '<p class="frp-list__note">Belege bekommst du nach jeder Abbuchung per E-Mail.</p></div></section>';
    return html;
  }

  function renderDialog() {
    var host = document.getElementById('frp-dialog-host');
    if (!host) { host = document.createElement('div'); host.id = 'frp-dialog-host'; host.className = 'frp frp--overlay'; document.body.appendChild(host); }
    var c = selected();
    if (!state.dialog || !c) { host.innerHTML = ''; document.body.style.overflow = ''; return; }
    var d = state.dialogData;
    var inner = '', title = '';
    var na = nextAttempt(c);
    var nextDel = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
    if (state.dialog === 'pause') {
      /* Kein Pausieren ohne Enddatum: der Dialog setzt nur einzelne
         Liefertermine aus, das Abo bleibt aktiv. */
      title = 'Lieferungen aussetzen';
      var opts = pauseOptions(c);
      var count = Math.min(Math.max(1, d.count || 2), opts.length || 1);
      if (c.attempts === null && !opts.length) {
        inner = '<div class="frp-loading"><span class="frp-spinner"></span><span>Termine laden …</span></div>';
      } else if (!opts.length) {
        inner = '<p>Wir finden gerade keine geplanten Termine. Versuch es gleich noch einmal oder schreib uns.</p><div class="frp-dialog__foot">' + btn('ghost', 'Schließen', 'close-dialog') + '</div>';
      } else {
        var after = opts[count] ? deliveryDate(c, opts[count].billing) : null;
        inner = '<p>Tippe auf die letzte Lieferung, die wir aussetzen sollen. Danach geht dein Abo automatisch weiter.</p>' +
          '<div class="frp-pause-list">' + opts.map(function (o, i) {
            var sel = i < count;
            return '<button type="button" class="frp-pause-row' + (sel ? ' is-selected' : '') + '" data-action="pause-count" data-count="' + (i + 1) + '" aria-pressed="' + (sel ? 'true' : 'false') + '">' +
              '<span class="frp-pause-row__idx">' + (i + 1) + '</span><span class="frp-pause-row__date">' + esc(fmtShort(deliveryDate(c, o.billing))) + '</span>' +
              '<span class="frp-pause-row__tag">' + (sel ? 'aussetzen' : '') + '</span></button>';
          }).join('') + '</div>' +
          '<p class="frp-small frp-pause-summary">' + (after ? 'Nächste Box dann am <strong>' + esc(fmtLong(after)) + '</strong>.' : 'Nächste Box: der erste Termin nach der Pause.') + ' Einzelne Wochen kannst du unter „Die nächsten Wochen“ jederzeit wieder aktivieren.</p>' +
          '<div class="frp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', count === 1 ? '1 Lieferung aussetzen' : count + ' Lieferungen aussetzen', 'confirm-pause', { id: c.id, count: count }) + '</div>';
      }
    } else if (state.dialog === 'swap') {
      var nv = boxVariants[Number(d.variant)] || {};
      title = 'Box wechseln';
      inner = '<p>Ab deiner nächsten Lieferung' + (nextDel ? ' am <strong>' + esc(fmtLong(nextDel)) + '</strong>' : '') + ' bekommst du <strong>' + esc(nv.product + (nv.variant ? ' (' + nv.variant + ')' : '')) + '</strong> für ' + esc(money(nv.price)) + ' pro Lieferung.</p>' +
        '<div class="frp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', 'Ja, wechseln', 'confirm-swap', { id: c.id, variant: nv.id }) + '</div>';
    } else if (state.dialog === 'cancel1') {
      title = 'Bevor du gehst …';
      var smaller = smallerBox(c);
      /* Halte-Angebote, die der Bestellschluss ohnehin blockiert, gar nicht erst anbieten. */
      var haltZu = aboGesperrt(c);
      inner = '<p>Muss es gleich die Kündigung sein? Vielleicht passt eine dieser Optionen besser:</p><div class="frp-options">' +
        (haltZu ? '' : '<button type="button" class="frp-option" data-action="open-pause" data-id="' + c.id + '"><span class="frp-option__title">Lieferungen aussetzen</span><span class="frp-option__desc">Ein paar Termine überspringen, ohne zu kündigen.</span></button>') +
        (haltZu ? '' : '<button type="button" class="frp-option" data-action="retention-skip" data-id="' + c.id + '"><span class="frp-option__title">Nächste Lieferung überspringen</span><span class="frp-option__desc">Einfach eine Woche Luft holen.</span></button>') +
        (smaller && !haltZu ? '<button type="button" class="frp-option" data-action="pick-box" data-id="' + c.id + '" data-variant="' + smaller.id + '" data-retention="1"><span class="frp-option__title">Kleinere Box wählen</span><span class="frp-option__desc">' + esc(smaller.product + (smaller.variant ? ' (' + smaller.variant + ')' : '') + ' für ' + money(smaller.price)) + ' – ab der nächsten Lieferung.</span></button>' : '') +
        (haltZu ? '<p class="frp-small frp-muted">Deine nächste Box ist schon in Vorbereitung und kommt noch. Danach ist Schluss, wenn du möchtest.</p>' : '') +
        '</div><div class="frp-dialog__foot">' + btn('ghost', 'Trotzdem kündigen', 'open-cancel2') + btn('primary', 'Ich bleibe', 'close-dialog') + '</div>';
    } else if (state.dialog === 'cancel2') {
      title = 'Wirklich kündigen?';
      inner = '<p>Dein Abo endet' + (nextDel ? ' vor der Lieferung am <strong>' + esc(fmtLong(nextDel)) + '</strong>' : ' sofort') + '. Schade, dass du gehst.</p>' +
        '<div class="frp-fields"><label class="frp-field">Magst du uns sagen, warum? (optional)<input type="text" id="frp-cancel-note" maxlength="200" placeholder="z. B. zu viel Obst, Umzug, Preis"></label></div>' +
        '<div class="frp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('secondary', 'Abo beenden', 'confirm-cancel', { id: c.id }) + '</div>';
    } else if (state.dialog === 'address') {
      title = 'Lieferadresse bearbeiten';
      var a = d.address || c.address;
      inner = '<div class="frp-fields"><div class="frp-fields frp-fields--2">' +
        '<label class="frp-field">Vorname<input type="text" name="firstName" value="' + esc(a.firstName) + '" autocomplete="given-name"></label>' +
        '<label class="frp-field">Nachname<input type="text" name="lastName" value="' + esc(a.lastName) + '" autocomplete="family-name"></label></div>' +
        '<label class="frp-field">Straße &amp; Hausnummer<input type="text" name="address1" value="' + esc(a.address1) + '" autocomplete="address-line1"></label>' +
        '<label class="frp-field">Adresszusatz<input type="text" name="address2" value="' + esc(a.address2) + '" autocomplete="address-line2"></label>' +
        '<div class="frp-fields frp-fields--2"><label class="frp-field">PLZ<input type="text" name="zip" value="' + esc(a.zip) + '" autocomplete="postal-code" inputmode="numeric"></label>' +
        '<label class="frp-field">Ort<input type="text" name="city" value="' + esc(a.city) + '" autocomplete="address-level2"></label></div>' +
        '<label class="frp-field">Telefon (für Rückfragen der Fahrer:innen)<input type="tel" name="phone" value="' + esc(a.phone) + '" autocomplete="tel"></label>' +
        '<label class="frp-field">Hinweis für die Zustellung<input type="text" name="note" value="' + esc(c.note) + '" maxlength="250" placeholder="z. B. Box bitte an die Kellertreppe stellen."></label></div>' +
        '<div class="frp-dialog__foot">' + btn('ghost', 'Abbrechen', 'close-dialog') + btn('primary', 'Speichern', 'save-address', { id: c.id }) + '</div>';
    }
    host.innerHTML = '<div class="frp-backdrop" data-action="close-dialog"><div class="frp-dialog frp-actionable" role="dialog" aria-modal="true" aria-labelledby="frp-dialog-title">' +
      '<div class="frp-dialog__head"><h2 class="frp-dialog__title" id="frp-dialog-title">' + esc(title) + '</h2><button type="button" class="frp-dialog__close" data-action="close-dialog" aria-label="Schließen">' + ICON.close + '</button></div>' + inner + '</div></div>';
    document.body.style.overflow = 'hidden';
    var first = host.querySelector('input, .frp-pause-row, .frp-option, .frp-dialog__foot .frp-btn');
    if (first) first.focus();
  }

  function renderToast() {
    var host = document.getElementById('frp-toast-host');
    if (!host) { host = document.createElement('div'); host.id = 'frp-toast-host'; host.className = 'frp frp--overlay frp-toast-wrap'; document.body.appendChild(host); }
    host.innerHTML = state.toast ? '<div class="frp-toast' + (state.toast.variant === 'error' ? ' frp-toast--error' : '') + '" role="status">' + esc(state.toast.msg) + '</div>' : '';
  }

  function headerHtml(lead) { return '<header class="frp__header"><h1 class="frp__h1">Meine Abos</h1>' + (lead ? '<p class="frp__lead">' + esc(lead) + '</p>' : '') + '</header>'; }
  function renderLoginGate() {
    app.innerHTML = headerHtml('Hier verwaltest du deine Boxen, Liefertermine und Extras.') +
      '<div class="frp-card frp-card--pad frp-login"><h2 class="frp__h2 frp__h2--sm">erst anmelden, dann loslegen.</h2><p>Melde dich mit deinem Kundenkonto an, damit wir dir deine Abos zeigen können.</p><p class="frp-small frp-muted" style="margin-top:8px">Du bist schon in deinem Shopify-Konto angemeldet und siehst das trotzdem? Dann einmal hier auf „Anmelden“ klicken, danach kennt dich auch der Shop.</p>' +
      '<div class="frp-actions"><a class="frp-btn frp-btn--primary" href="' + esc(cfg.loginUrl) + '">Anmelden</a><a class="frp-btn frp-btn--ghost" href="' + esc(cfg.registerUrl) + '">Konto anlegen</a></div></div>';
  }

  function render() {
    if (state.needsLogin) { renderLoginGate(); return; }
    if (state.error) {
      app.innerHTML = headerHtml('') + '<div class="frp-card frp-card--pad frp-error"><h2 class="frp__h2 frp__h2--sm">Da hakt gerade etwas.</h2><p class="frp-small">Wir konnten deine Abos nicht laden. Versuch es gleich noch einmal oder schreib uns.</p><code>' + esc(state.error) + '</code><div class="frp-actions">' + btn('primary', 'Noch einmal versuchen', 'retry') + '</div></div>';
      return;
    }
    var c = selected();
    app.innerHTML = c ? renderDetail(c) : renderOverview();
    renderDialog();
    renderToast();
    debugPanel();
    scrollBoxRowToActive();
  }
  /* Wischbare Box-Zeile: aufgeklappte Karte ohne Seitensprung in den sichtbaren Bereich holen */
  function scrollBoxRowToActive() {
    var row = app.querySelector('.frp-boxes'); if (!row) return;
    var card = row.querySelector('.frp-box.is-active'); if (!card) return;
    var left = card.offsetLeft - row.offsetLeft;
    var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    var target = Math.max(0, left - pad);
    if (target < row.scrollLeft || left + card.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = target;
  }

  function smallerBox(c) {
    if (!c.box) return null;
    var cur = boxVariants[c.box.variantId];
    var candidates = (cfg.boxes || []).filter(function (x) { return x.available !== false && x.id !== c.box.variantId && (!cur || x.productId === cur.productId) && x.price < (cur ? cur.price : c.box.price); });
    candidates.sort(function (a, b) { return b.price - a.price; });
    return candidates[0] || null;
  }

  /* ---------- Aktionen ---------- */
  /* Aktion ausführen. opts.optimistic(c) ändert den Stand sofort im Portal (kein Ausgrauen, keine Wartezeit),
     danach bestätigt der Vertrag von Appstle den Stand. Schlägt es fehl, wird der echte Stand geladen. */
  function run(promise, okMsg, id, opts) {
    opts = opts || {};
    var c = id ? state.contracts.filter(function (x) { return x.id === id; })[0] : null;
    var optimistic = false;
    if (opts.optimistic && c) {
      try { opts.optimistic(c); optimistic = true; } catch (e) {}
    }
    if (optimistic) { app.classList.add('is-saving'); render(); if (okMsg) showToast(okMsg); }
    else setBusy(true);
    var finish = function () { setBusy(false); app.classList.remove('is-saving'); };
    return promise.then(function () {
      /* Aktion war erfolgreich – ein Fehler beim Neuladen darf sie nicht als gescheitert melden */
      return id ? reloadContract(id).then(null, function () {}) : null;
    }).then(function () {
      finish(); render();
      if (okMsg && !optimistic) showToast(okMsg);
    }, function (err) {
      /* Fehlgeschlagen oder teilweise ausgeführt: echten Stand laden, damit nichts Falsches stehen bleibt */
      var refresh = (id && (optimistic || (err && err.partial))) ? reloadContract(id).then(null, function () {}) : Promise.resolve();
      return refresh.then(function () {
        finish(); render();
        if (DEBUG && err) console.warn('[fruvi-abo] Appstle-Fehler', err.status, err.message);
        showToast(freundlicherFehler(err, c), 'error');
      });
    });
  }
  /* Fehlermeldungen von Appstle in verständliche Sätze übersetzen (ohne „UserGeneratedError“ und Statuscode).
     Appstle sperrt Kündigen und Pausieren in den Tagen vor der nächsten Abbuchung; dafür nennen wir das Datum,
     ab dem es wieder geht, und den Weg per Mail. */
  function freundlicherFehler(err, c) {
    var raw = String((err && err.message) || '')
      .replace(/^\s*[A-Za-z]*Error\s*:\s*/, '')
      .replace(/\s*\(Status \d+\)\s*$/, '')
      .trim();
    var status = err && err.status;
    var mail = cfg.shopEmail || 'hello@fruvi.de';
    var tagMonat = function (d) { return d.getDate() + '. ' + MON_S[d.getMonth()]; };
    if (/vor\s+\d+\s+Tag|before\s+\d+\s+day|within\s+\d+\s+day|next (order|billing) date/i.test(raw)) {
      var na = c ? nextAttempt(c) : null;
      var abbuchung = c ? (na ? parseDate(na.billingDate) : c.nextBillingDate) : null;
      return 'Deine nächste Box ist schon fest eingeplant' +
        (abbuchung ? ' (Abbuchung am ' + tagMonat(abbuchung) + ')' : '') +
        '. ' + (abbuchung ? 'Ab dem ' + tagMonat(addDays(abbuchung, 1)) + ' kannst du wieder pausieren und kündigen.' : 'Danach kannst du wieder pausieren und kündigen.') +
        ' Kündigen geht jederzeit auch per Mail an ' + mail + '.';
    }
    if (err && err.network) return raw || 'Gerade gibt es keine Verbindung. Bitte versuch es gleich noch einmal.';
    if (/timeout|failed to fetch|networkerror/i.test(raw)) return 'Gerade gibt es keine Verbindung. Bitte versuch es gleich noch einmal.';
    if (status === 401 || status === 403) return 'Deine Anmeldung ist abgelaufen. Bitte lade die Seite neu und melde dich wieder an.';
    if (status >= 500) return 'Unser Abo-System antwortet gerade nicht. Bitte versuch es in ein paar Minuten noch einmal.';
    if (status === 0 && raw) return raw;
    return raw ? 'Das hat leider nicht geklappt: ' + raw : 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';
  }

  /* Mehrere Appstle-Aufrufe mit begrenzter Parallelität (schneller als nacheinander, schonender als alle auf einmal) */
  function runBatch(items, worker, limit) {
    var i = 0, done = 0, failed = null;
    function next() {
      if (failed || i >= items.length) return Promise.resolve();
      var item = items[i++];
      return worker(item).then(function () { done++; }, function (err) { failed = failed || err; }).then(next);
    }
    var lanes = []; for (var k = 0; k < Math.min(limit || 3, items.length); k++) lanes.push(next());
    return Promise.all(lanes).then(function () {
      if (!failed) return done;
      if (!done) throw failed;
      var e = new Error(done + ' von ' + items.length + ' erledigt, dann kam: ' + (failed && failed.message));
      e.status = failed && failed.status; e.partial = true; throw e;
    });
  }
  function markAttempt(c, attemptId, status) {
    [c.attempts, c.history].forEach(function (list) { (list || []).forEach(function (a) { if (String(a.id) === String(attemptId)) a.status = status; }); });
  }

  var actions = {
    'retry': function () { init(); },
    'open': function (d) {
      var c = state.contracts.filter(function (x) { return x.id === Number(d.id); })[0];
      if (!c) return;
      state.selectedId = c.id; state.dialog = null; state.boxProduct = null; state.navigated = true;
      try { history.replaceState(null, '', location.pathname + '?abo=' + c.id); } catch (e) {}
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
      render();
      var p = loadDetailData(c); if (p) p.then(render);
    },
    'back': function () {
      state.selectedId = null; state.dialog = null; state.navigated = true;
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      render();
    },
    'close-dialog': function () { state.dialog = null; state.dialogData = {}; renderDialog(); },
    'open-pause': function (d) {
      state.dialog = 'pause'; state.dialogData = { count: 2 }; renderDialog();
      var c = selected();
      var p = c && loadDetailData(c); if (p) p.then(function () { if (state.dialog === 'pause') renderDialog(); });
    },
    'pause-count': function (d) { state.dialogData.count = Number(d.count) || 1; renderDialog(); },
    'confirm-pause': function (d) {
      var c = selected(); if (!c) return;
      var opts = pauseOptions(c).slice(0, Number(d.count) || 1);
      if (!opts.length) return;
      state.dialog = null; state.dialogData = {}; renderDialog();
      var withIds = opts.every(function (o) { return o.id; });
      /* Mit Termin-IDs parallel überspringen; ohne IDs muss es nacheinander gehen (skip-upcoming nimmt immer den nächsten) */
      var chain = withIds ? runBatch(opts, function (o) { return Appstle.skip(c.id, o.id); }, 3)
        : runBatch(opts, function () { return Appstle.skipUpcoming(c.id); }, 1);
      var last = deliveryDate(c, opts[opts.length - 1].billing);
      run(chain, opts.length === 1 ? 'Alles klar – ' + fmtShort(last) + ' wird übersprungen.' : 'Ausgesetzt bis ' + fmtShort(last) + ', danach geht es automatisch weiter.', c.id,
        withIds ? { optimistic: function (x) { opts.forEach(function (o) { markAttempt(x, o.id, 'SKIPPED'); }); } } : null);
    },
    'resume': function (d) {
      var c = selected(); if (!c) return;
      run(Appstle.status(c.id, 'ACTIVE'), 'Willkommen zurück! Deine nächste Box ist unterwegs zum nächsten Termin.', c.id, { optimistic: function (x) { x.status = 'ACTIVE'; } });
    },
    'reactivate': function (d) {
      var c = byId(Number(d.id)); if (!c) return;
      run(Appstle.status(c.id, 'ACTIVE'), '„' + boxTitle(c) + '“ ist wieder aktiv. Willkommen zurück!', c.id);
    },
    'skip-next': function (d) {
      var c = selected(); if (!c) return;
      var na = nextAttempt(c);
      var del = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
      run(na ? Appstle.skip(c.id, na.id) : Appstle.skipUpcoming(c.id), 'Alles klar – ' + fmtShort(del) + ' wird übersprungen.', c.id, na ? { optimistic: function (x) { markAttempt(x, na.id, 'SKIPPED'); } } : null);
    },
    'retention-skip': function (d) {
      var c = selected(); if (!c) return;
      state.dialog = null; renderDialog();
      var na = nextAttempt(c);
      var del = deliveryDate(c, na ? parseDate(na.billingDate) : c.nextBillingDate);
      run(na ? Appstle.skip(c.id, na.id) : Appstle.skipUpcoming(c.id), fmtShort(del) + ' wird übersprungen – schön, dass du bleibst.', c.id, na ? { optimistic: function (x) { markAttempt(x, na.id, 'SKIPPED'); } } : null);
    },
    'skip': function (d) { var c = selected(); if (!c) return; run(Appstle.skip(c.id, d.attempt), 'Lieferung übersprungen.', c.id, { optimistic: function (x) { markAttempt(x, d.attempt, 'SKIPPED'); } }); },
    'unskip': function (d) { var c = selected(); if (!c) return; run(Appstle.unskip(c.id, d.attempt), 'Diese Woche wird wieder geliefert.', c.id, { optimistic: function (x) { markAttempt(x, d.attempt, 'QUEUED'); } }); },
    'unskip-all': function (d) {
      var c = selected(); if (!c) return;
      var list = queuedAttempts(c).filter(function (a) { return String(a.status).toUpperCase() === 'SKIPPED'; });
      if (!list.length) return;
      var chain = runBatch(list, function (a) { return Appstle.unskip(c.id, a.id); }, 3);
      run(chain, 'Pause beendet – ' + (list.length === 1 ? 'die Lieferung kommt' : 'alle ' + list.length + ' Lieferungen kommen') + ' wieder wie gewohnt.', c.id,
        { optimistic: function (x) { list.forEach(function (a) { markAttempt(x, a.id, 'QUEUED'); }); } });
    },
    'open-cancel': function () { state.dialog = 'cancel1'; renderDialog(); },
    'open-cancel2': function () { state.dialog = 'cancel2'; renderDialog(); },
    'confirm-cancel': function (d) {
      var c = selected(); if (!c) return;
      var noteEl = document.getElementById('frp-cancel-note');
      var note = noteEl ? noteEl.value.trim() : '';
      state.dialog = null; renderDialog();
      run(Appstle.cancel(c.id, note ? 'OTHER' : '', note), 'Dein Abo ist gekündigt. Die Tür bleibt offen.', c.id);
    },
    'pick-product': function (d) {
      state.boxProduct = Number(d.product) || null;
      render();
      var sizes = app.querySelector('.frp-sizes');
      if (sizes && sizes.scrollIntoView) sizes.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    },
    'pick-box': function (d) {
      var c = selected(); if (!c || !c.box) return;
      var v = boxVariants[Number(d.variant)]; if (!v || v.id === c.box.variantId) return;
      if (d.retention) {
        state.dialog = null; renderDialog();
        actions['confirm-swap']({ id: c.id, variant: v.id });
        return;
      }
      state.dialog = 'swap'; state.dialogData = { variant: v.id }; renderDialog();
    },
    'confirm-swap': function (d) {
      var c = selected(); if (!c || !c.box) return;
      var v = boxVariants[Number(d.variant)]; if (!v || v.id === c.box.variantId) return;
      state.dialog = null; state.dialogData = {}; renderDialog();
      state.boxProduct = v.productId;
      run(Appstle.replaceVariant(c.id, c.box, v.id), v.product + (v.variant ? ' (' + v.variant + ')' : '') + ' ab der nächsten Lieferung. Gute Wahl.', c.id,
        { optimistic: function (x) { if (!x.box) return; x.box.variantId = v.id; x.box.productId = v.productId; x.box.title = v.product; x.box.variantTitle = v.variant || ''; x.box.price = v.price; x.box.lineTotal = v.price * (x.box.quantity || 1); } });
    },
    'pick-frequency': function (d) {
      var c = selected(); if (!c) return;
      var f = (c.frequencies || [])[Number(d.index)]; if (!f) return;
      /* Laeuft das Abo schon so, wird nichts gesendet. Appstle rechnet bei jedem
         Frequenzwechsel den naechsten Termin neu ("Immediately update next order date
         when frequency changes", Methode "Current Next Billing Date"): der neue Termin
         ist der aktuelle plus ein Intervall. Ein Tipp auf den bereits aktiven Rhythmus
         haette die Lieferung also um einen vollen Zyklus nach hinten geschoben, ohne
         dass sich etwas geaendert haette. Mehrere Tipps summieren sich. */
      if (istAktiverRhythmus(c, f)) { showToast('Dein Abo läuft schon in diesem Rhythmus.'); return; }
      run(Appstle.setFrequency(c.id, f), 'Neuer Rhythmus gespeichert.', c.id, { optimistic: function (x) {
        (x.frequencies || []).forEach(function (o) { o.selected = (o === f); });
        if (x.box && f.sellingPlanId) x.box.sellingPlanId = f.sellingPlanId;
      } });
    },
    'extra-inc': function (d) {
      var c = selected(); if (!c) return;
      var vid = Number(d.variant);
      var line = c.extras.filter(function (l) { return l.variantId === vid; })[0];
      var p = extraVariants[vid];
      run(line ? Appstle.lineQty(c.id, line.lineId, line.quantity + 1) : Appstle.addLine(c.id, vid, 1), (p ? p.name : 'Extra') + ' kommt in die nächste Box.', c.id);
    },
    'extra-dec': function (d) {
      var c = selected(); if (!c) return;
      var vid = Number(d.variant);
      var line = c.extras.filter(function (l) { return l.variantId === vid; })[0]; if (!line) return;
      run(line.quantity > 1 ? Appstle.lineQty(c.id, line.lineId, line.quantity - 1) : Appstle.removeLine(c.id, line.lineId), line.quantity > 1 ? 'Menge angepasst.' : 'Extra entfernt.', c.id);
    },
    'open-address': function () { state.dialog = 'address'; state.dialogData = {}; renderDialog(); },
    'save-address': function (d) {
      var c = selected(); if (!c) return;
      var host = document.getElementById('frp-dialog-host');
      var get = function (n) { var el = host.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      var addr = {
        firstName: get('firstName'), lastName: get('lastName'), address1: get('address1'), address2: get('address2'),
        city: get('city'), zip: get('zip'), phone: get('phone'),
        company: c.address.company, province: c.address.province, provinceCode: c.address.provinceCode,
        country: c.address.country || 'Germany', countryCode: c.address.countryCode || 'DE'
      };
      var note = get('note');
      if (!addr.address1 || !addr.zip || !addr.city) { showToast('Straße, PLZ und Ort brauchen wir mindestens.', 'error'); return; }
      state.dialog = null; renderDialog();
      var jobs = [Appstle.address(c.id, addr)];
      if (note !== (c.note || '')) jobs.push(Appstle.note(c.id, note));
      run(Promise.all(jobs), 'Adresse gespeichert.', c.id);
    },
    'payment': function (d) {
      var c = selected(); if (!c) return;
      run(Appstle.paymentEmail(c.id), 'Wir haben dir einen sicheren Link zum Ändern der Zahlart gemailt.', null);
    }
  };

  /* Bestellschluss zusaetzlich beim Klick pruefen: zwischen Rendern und Klick kann der
     Tag wechseln, und ein disabled laesst sich im Browser entfernen. Die Sperre ist damit
     nicht nur eine Anzeige. Verbindlich bleibt ohnehin, was Appstle annimmt. */
  var CUTOFF_VERTRAG = { 'skip-next': 1, 'unskip-all': 1, 'open-pause': 1, 'pause-count': 1, 'confirm-pause': 1, 'pick-box': 1, 'confirm-swap': 1, 'pick-frequency': 1, 'extra-inc': 1, 'extra-dec': 1, 'retention-skip': 1 };
  /* Kuendigen nur sperren, wenn es eingeschaltet ist. Siehe docs/abo-portal-bestellschluss.md
     zum Vorbehalt aus § 312k BGB. */
  var CUTOFF_KUENDIGUNG = { 'open-cancel': 1, 'open-cancel2': 1, 'confirm-cancel': 1 };
  var CUTOFF_TERMIN = { 'skip': 1, 'unskip': 1 };
  /* Diese Aktionen gehen auch, solange der Zwischenspeicher aktualisiert wird: sie ändern nichts bei Appstle */
  var REFRESH_OK = { 'open': 1, 'back': 1, 'close-dialog': 1, 'retry': 1, 'pick-product': 1 };
  function cutoffBlockiert(aktion, daten) {
    if (!cutoffTage()) return false;
    var c = selected(); if (!c) return false;
    if (c.status !== 'ACTIVE' && c.status !== 'FAILED') return false;
    if (CUTOFF_KUENDIGUNG[aktion]) return cfg.cutoffLockCancel !== false && aboGesperrt(c);
    if (CUTOFF_VERTRAG[aktion]) return aboGesperrt(c);
    if (CUTOFF_TERMIN[aktion]) {
      var a = (c.attempts || []).filter(function (x) { return String(x.id) === String(daten && daten.attempt); })[0];
      return a ? terminGesperrt(deliveryDate(c, parseDate(a.billingDate))) : aboGesperrt(c);
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    if (MOUNT !== window.__frpMount) return;
    var el = e.target.closest('[data-action]');
    if (!el) return;
    if (el.closest('#frp-dialog-host') || root.contains(el)) {
      /* Klicks im Dialog nicht als Backdrop-Klick werten */
      if (el.classList.contains('frp-backdrop') && e.target !== el) return;
      if (state.busy && el.dataset.action !== 'close-dialog') return;
      if (state.refreshing && !REFRESH_OK[el.dataset.action]) { showToast('Einen Moment, wir holen den aktuellen Stand deiner Abos.'); e.preventDefault(); return; }
      var fn = actions[el.dataset.action];
      if (fn) {
        e.preventDefault();
        if (cutoffBlockiert(el.dataset.action, el.dataset)) {
          showToast(CUTOFF_KUENDIGUNG[el.dataset.action]
            ? 'Deine nächste Box ist schon in Vorbereitung. Kündigen geht danach wieder – oder jederzeit per Mail an ' + (cfg.shopEmail || 'hello@fruvi.de') + '.'
            : 'Diese Lieferung ist schon in Vorbereitung – Änderungen wirken ab der Lieferung danach.');
          return;
        }
        fn(el.dataset, el, e);
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (MOUNT !== window.__frpMount) return;
    if (e.key === 'Escape' && state.dialog) actions['close-dialog']();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.frp-sub[data-action="open"]')) { e.preventDefault(); actions.open(e.target.dataset); }
  });

  /* ---------- Start ---------- */
  function resolveCustomer() {
    if (cfg.customerId) return Promise.resolve(cfg.customerId);
    /* Liquid kennt keinen Kunden – Appstle fragen, ob eine Kundensession besteht */
    return api('GET', '/logged-in-customer').then(function (res) {
      var id = num(res && (res.customerId || res.id || res));
      if (!id) throw new Error('not logged in');
      cfg.customerId = id;
      return id;
    });
  }

  var DEBUG = /[?&]frp_debug=1/.test(location.search), debugProbe = null;
  function debugPanel() {
    if (!DEBUG) return;
    var old = document.getElementById('frp-debug'); if (old) old.parentNode.removeChild(old);
    var box = document.createElement('pre');
    box.id = 'frp-debug';
    box.style.cssText = 'margin-top:24px;padding:12px;background:#fff;border:1px dashed #E3E3D2;border-radius:8px;font-size:12px;white-space:pre-wrap;color:#4A5F53';
    box.textContent = 'Diagnose\nLiquid-Kunde: ' + (cfg.customerId || 'keiner') + '\nProxy-Basis: ' + API_BASE + '\nStatus: ' + (state.needsLogin ? 'keine Kundensession' : state.error ? 'Fehler: ' + state.error : 'ok, ' + state.contracts.length + ' Verträge') +
      (state.lastError ? '\nLetzter API-Fehler: ' + state.lastError.method + ' ' + state.lastError.url + '\n  Status ' + state.lastError.status + ': ' + state.lastError.body : '') +
      (function () { var c = selected(); if (!c) return ''; return '\nTermine (top-orders): ' + (c.attempts ? c.attempts.length + ' → ' + c.attempts.map(function (a) { return a.status + '@' + String(a.billingDate).slice(0, 10); }).join(', ') : 'nicht geladen') +
        '\nHistorie (past-orders): ' + (c.history ? c.history.length + ' → ' + c.history.map(function (a) { return a.status + '@' + String(a.billingDate).slice(0, 10); }).join(', ') : 'nicht geladen') +
        '\nRoh top-orders: ' + (state.debugRaw.topOrders || '–') + '\nRoh past-orders: ' + (state.debugRaw.pastOrders || '–') +
        '\nRoh fulfillments: ' + (state.debugRaw.fulfillments || '–') + '\nErkannt: ' + JSON.stringify(c.fulfillments || {}); })();
    var keepErr = state.lastError;
    debugProbe = debugProbe || api('GET', '/logged-in-customer').then(function (r) { return 'logged-in-customer: ' + JSON.stringify(r).slice(0, 200); }, function (e) { state.lastError = keepErr; return 'logged-in-customer: Fehler ' + (e.status || '') + ' ' + String(e.message).slice(0, 200); });
    debugProbe.then(function (t) { box.textContent += '\n' + t; });
    app.appendChild(box);
  }

  /* Theme-Editor: kein Kunde, kein Appstle – Beispieldaten, damit sich die Section einrichten lässt */
  function loadDemo() {
    var b = (cfg.boxes || [])[0] || { id: 0, productId: 0, product: 'Mixbox', variant: '1-2 Personen', price: 26.99 };
    var next = new Date(); next.setDate(next.getDate() + ((3 - next.getDay() + 7) % 7 || 7) - Number(cfg.deliveryOffsetDays || 0));
    var mk = function (i, status) { return { id: 9000 + i, status: status, billingDate: addDays(next, i * 7).toISOString() }; };
    var c = normalizeContract({
      id: 1, status: 'ACTIVE', nextBillingDate: next.toISOString(), createdAt: addDays(next, -120).toISOString(),
      billingPolicy: { interval: 'WEEK', intervalCount: 1 }, deliveryPolicy: { interval: 'WEEK', intervalCount: 1 },
      lines: [{ id: 'demo-line', variantId: b.id, productId: b.productId, title: b.product, variantTitle: b.variant, quantity: 1, currentPrice: { amount: String(b.price) }, sellingPlanId: (b.plans && b.plans[0]) ? b.plans[0].id : null }],
      deliveryMethod: { address: { firstName: 'Jana', lastName: 'Beispiel', address1: 'Obstgartenweg 12', zip: '92318', city: 'Neumarkt' } },
      customerPaymentMethod: { instrument: { brand: 'visa', lastDigits: '4242', expiryMonth: 2, expiryYear: 2028 } },
      customAttributes: []
    });
    c.attempts = [0, 1, 2, 3, 4, 5].map(function (i) { return mk(i, i === 1 ? 'SKIPPED' : 'QUEUED'); });
    c.history = [1, 2, 3].map(function (i) { return { id: 8000 + i, status: 'SUCCESS', billingDate: addDays(next, -i * 7).toISOString(), orderName: '#10' + (40 - i), orderAmount: b.price }; });
    /* Die juengste Bestellung ist bezahlt, aber noch nicht raus; die aelteren sind geliefert. */
    c.fulfillments = { '1039': false, '1038': true, '1037': true };
    c.frequencies = liquidFrequencies(c);
    state.contracts = [c];
    if (!cfg.customerFirstName) cfg.customerFirstName = 'Jana';
    if (!(cfg.orders || []).length) {
      var y = new Date().getFullYear(), m0 = new Date().getMonth();
      cfg.orders = [6, 5, 4, 3, 2, 1, 0].map(function (k) { var d = new Date(y, m0 - k, 8); return { date: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(), grams: 5200 + k * 300, boxes: 1, cancelled: false }; });
      cfg.ordersCount = cfg.orders.length;
    }
    render();
    var note = document.createElement('div');
    note.className = 'frp-card frp-card--tip frp-card--pad frp-demo-note';
    note.textContent = 'Vorschau im Theme-Editor: Beispieldaten ohne Verbindung zu Appstle. Eingeloggte Kund:innen sehen hier ihre echten Abos.';
    app.insertBefore(note, app.firstChild);
  }

  /* Fuer die Statistik wird die Lieferhistorie jedes Vertrags gebraucht. Vorab geholt wird sie nur fuer die
     ersten drei, deshalb hier nachladen und danach neu zeichnen. Laeuft nach dem ersten Zeichnen, blockiert
     die Seite also nicht. */
  function ensureStatsData() {
    if (!cfg.showStats || (cfg.orders || []).length) return;
    var jobs = [];
    (state.contracts || []).forEach(function (c) {
      var p = loadDetailData(c);
      if (p) jobs.push(p);
    });
    if (!jobs.length) return;
    /* Nicht neu zeichnen, solange ein Dialog offen ist: render() baut den Dialog neu auf und wuerde bereits
       ausgefuellte Eingaben verwerfen. Die Karte kommt dann beim naechsten regulaeren Zeichnen. */
    Promise.all(jobs).then(function () { if (!state.dialog) render(); }, function () {});
  }

  /* Nach dem Laden: Abo vorwählen (?abo=… oder das einzige), zeichnen, Details des gewählten Abos nachladen */
  function showLoaded() {
    if (state.selectedId && !byId(state.selectedId)) state.selectedId = null;
    if (!state.selectedId && !state.navigated) {
      var m = location.search.match(/[?&]abo=(\d+)/);
      var pre = m ? Number(m[1]) : (state.contracts.length === 1 ? state.contracts[0].id : null);
      if (pre && byId(pre)) state.selectedId = pre;
    }
    /* Einen offenen Dialog nicht neu aufbauen, sonst gehen Eingaben verloren */
    if (!state.dialog) render();
    var c = selected(); var p = c && loadDetailData(c);
    if (p) p.then(function () { if (!state.dialog) render(); });
  }

  function init() {
    state.error = null; state.needsLogin = false;
    if (cfg.designMode) { loadDemo(); return; }
    /* Stand der letzten Anzeige sofort zeigen, Appstle aktualisiert im Hintergrund */
    var cached = cfg.customerId ? loadCache() : null;
    if (cached) { state.contracts = sortContracts(cached); setRefreshing(true); showLoaded(); }
    resolveCustomer().then(function () {
      return loadAll(function () { setRefreshing(false); showLoaded(); });
    }).then(function () {
      setRefreshing(false);
      showLoaded();
      saveCache();
      ensureStatsData();
    }, function (err) {
      setRefreshing(false);
      var status = err && err.status;
      /* 401/403 = keine Kundensession. Alles andere (404, 5xx, HTML statt JSON) ist ein Verbindungs- oder Pfadproblem. */
      if (status === 401 || status === 403 || (!cfg.customerId && !status)) { clearCache(); state.contracts = []; state.needsLogin = true; render(); return; }
      if (cached) { render(); showToast('Deine Abos konnten gerade nicht aktualisiert werden. Du siehst den letzten Stand.', 'error'); return; }
      if (status === 404 || (err && err.message && /<html|<!doctype/i.test(err.message))) {
        state.error = 'Appstle antwortet nicht unter „' + API_BASE + '“ (Status ' + (status || '?') + '). Bitte den App-Proxy-Pfad in den Section-Einstellungen prüfen.';
      } else {
        state.error = (err && err.message) || 'Unbekannter Fehler';
      }
      render();
    });
  }
  init();
}

  mount();
  /* Theme-Editor: nach jeder Einstellungsänderung wird die Section neu gerendert */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.frp[data-section-id]')) mount();
  });
})();
